/* hp-procedencia fuente=landing-v2.html sha256=371c0a22ced801b7bf7548d95c12c7f7ef62cf120a58e8bb442560eb92b5c8ff — generado por _build-section.cjs, no editar */
(function () {
  function init(host) {
    if (!host) return;
    var root = host.shadowRoot;
    // Fallback: si el navegador no adopto el <template shadowrootmode> (p.ej. inyectado por JS en el editor)
    if (!root) {
      var tpl = host.querySelector('template[shadowrootmode]');
      if (tpl && host.attachShadow) { root = host.attachShadow({ mode: 'open' }); root.appendChild(tpl.content); host.removeChild(tpl); }
    }
    if (!root || host.dataset.hpInitHpLandingV2Host === '1') return;
    host.dataset.hpInitHpLandingV2Host = '1';
    /* ROOT COMPUESTO (18-ago-2026): mientras la landing se publica seccion por seccion conviven DOS
     * cuerpos en la pagina (nuevo arriba, viejo abajo), cada uno en su shadow root. El estado de la
     * moneda es global (window.HP_SELECTED_CURRENCY) pero cada JS repintaba solo SU raiz; y un ancla
     * (#solicitar) puede vivir en el otro cuerpo hasta que su bloque migre. root busca primero en
     * la raiz propia y despues en las demas raices de la landing: querySelectorAll devuelve la union.
     * Con un solo cuerpo se comporta exactamente como antes. */
    var propio = root;
    var otrasRaices = function () { var out = []; document.querySelectorAll('.hp-landing-host, .hp-landing-v2-host').forEach(function (h) { if (h !== host && h.shadowRoot) out.push(h.shadowRoot); }); return out; };
    root = {
      host: host,
      getElementById: function (id) { var e = propio.getElementById(id); if (e) return e; var rs = otrasRaices(); for (var i = 0; i < rs.length; i++) { e = rs[i].getElementById(id); if (e) return e; } return null; },
      querySelector: function (s) { var e = propio.querySelector(s); if (e) return e; var rs = otrasRaices(); for (var i = 0; i < rs.length; i++) { e = rs[i].querySelector(s); if (e) return e; } return null; },
      querySelectorAll: function (s) { var out = Array.prototype.slice.call(propio.querySelectorAll(s)); otrasRaices().forEach(function (r) { out = out.concat(Array.prototype.slice.call(r.querySelectorAll(s))); }); return out; },
      addEventListener: function () { return propio.addEventListener.apply(propio, arguments); },
      removeEventListener: function () { return propio.removeEventListener.apply(propio, arguments); },
      appendChild: function (n) { return propio.appendChild(n); },
      contains: function (n) { return propio.contains(n); }
    };

    // ---- comportamientos de la landing (scopeados al shadow root) ----
    try {
      /* ═══ HP_PIXEL — LOS EVENTOS QUE SE PUEDEN VER ══════════════════════════════════════════
           *
           * POR QUÉ EXISTE (23-ago-2026)
           * Enrique valida el píxel como cualquiera: abre Pixel Helper y mira. Y no veía los eventos que
           * importan. Medido con Chrome real: el píxel de Shopify manda `PageView` en toda la tienda y
           * `ViewContent` en la ficha de producto, y **nada más**. Todo lo demás —el interés por el libro,
           * el cuestionario, el cobro— viajaba SOLO por CAPI desde el Worker, que ninguna extensión puede
           * ver. Así que existían para Meta, pero no para quien los quisiera comprobar.
           *
           * Esto los manda TAMBIÉN por el navegador. No es duplicar: es la configuración que Meta
           * recomienda (navegador + servidor), y por eso lo importante aquí es el `eventID`.
           *
           * ⚠️ LA REGLA QUE NO SE PUEDE ROMPER — deduplicación.
           * Meta considera dos eventos el MISMO si coinciden **`event_name` y `eventID`**, dentro de una
           * ventana de 48 h (doc: developers.facebook.com/docs/marketing-api/conversions-api/
           * deduplicate-pixel-and-server-events). Por eso los tres eventos del cobro reutilizan EXACTAMENTE
           * el id que el Worker ya usa en CAPI — `ic_<pi>`, `api_<pi>`, `pur_<pi>`—. Cambiar uno de los dos
           * lados sin el otro no «arregla» nada: hace que cada compra se cuente dos veces.
           *
           * LOS `Lead` DE ESTE ARCHIVO no van por CAPI —solo por aquí—, así que su id no deduplica con
           * nada del servidor. OJO con lo que eso NO significa: el `Lead` del emergente sí va por las dos
           * vías, pero lo manda `klaviyo-meta-lead.js`, un script del tema. Ver la nota del final.
           *
           * NO manda `PageView` ni `ViewContent`: ya los manda Shopify. Añadirlos sería contarlos dos
           * veces, porque el `eid` de Shopify no lo controlamos.
           */
          window.HP_PIXEL = (function () {
            var yaSalio = {};   // dentro de esta carga, un mismo eventID no se manda dos veces
      
            function hay() { return typeof window.fbq === 'function'; }
      
            /* UN COBRO DE PRUEBA NO ES UNA CONVERSIÓN, tampoco desde el navegador (H-69, 23-ago-2026).
             * `HP_PAY_TEST` lo pone quien está probando (`?pay_test=…`) y es el ÚNICO modo de prueba que
             * funciona en healthandpaws.com contra el Worker de verdad: cobra el mínimo en vez del precio,
             * pero el píxel de la tienda está delante y se tragaba el `Purchase` como si fuera una venta.
             * Encima sin gemelo de servidor que lo dedupliqueara, porque el Worker sí lo salta — así que
             * la prueba entraba SOLA en la analítica con la que se pauta.
             *
             * Va dentro de `meta()` y no repartido por cada llamada, para que proteja también a los
             * eventos que se añadan mañana sin que nadie tenga que acordarse.
             *
             * NO se mira `HP_PIDE_PRUEBA` (el `?entorno=prueba` que habla con el Worker de test), y es a
             * propósito: ese modo solo existe sirviendo la página desde localhost, donde el píxel de la
             * tienda —que lo inyecta Shopify -- no existe. Lo único que llega ahí es el píxel postizo que
             * levanta `_qa-pixel-cobro.mjs` para poder medir estos ganchos, y ESA corrida se contiene en
             * la red: aborta los beacons antes de que salgan. Contenerlo ahí es más fuerte que un `if`
             * aquí (atrapa cualquier otra cosa que intente hablar con Meta), y además deja medible lo que
             * un gate en este punto volvería invisible. Que siga conteniéndose no se supone: el examen
             * comprueba que ni una sola petición a facebook.com llegó a completarse. */
            function enPruebas() {
              try { return !!window.HP_PAY_TEST; } catch (_) { return false; }
            }
      
            /** Manda a Meta y devuelve si salió. `id` es el eventID de deduplicación. */
            function meta(nombre, datos, id) {
              if (!hay()) return false;
              if (enPruebas()) return false;
              if (id) { if (yaSalio[id]) return false; yaSalio[id] = 1; }
              try {
                window.fbq('track', nombre, datos || {}, id ? { eventID: id } : undefined);
                return true;
              } catch (_) { return false; }
            }
      
            /** Un id de una sola vez para los eventos que no tienen pareja en el servidor. */
            function idSuelto(prefijo) {
              return prefijo + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
            }
      
            /* ═══ QUIÉN ES, HASTA DONDE SE SEPA (23-ago-2026, encargo de Enrique) ══════════════════════
             *
             * «Que hasta donde llegó el evento recopile la información.» Hasta hoy los eventos de
             * navegador no llevaban NADA de la persona: Meta recibía una compra sin saber de quién, y la
             * emparejaba solo por la cookie. El correo, el teléfono y el nombre los teníamos delante.
             *
             * Meta llama a esto emparejamiento avanzado y se pone con `fbq('init', <pixel>, {…})`. Que
             * funcione sobre un píxel que inicializa SHOPIFY —no nosotros— no se dio por hecho: se midió
             * en la tienda el 23-ago. Con datos, el beacon pasa de GET a POST y viaja con `ud[em]`,
             * `ud[ph]`, `ud[fn]`, `ud[ln]`, `ud[ct]`, `ud[country]` y `ud[external_id]`, TODOS hasheados
             * por el propio píxel — nosotros nunca mandamos nada en claro.
             *
             * Es ACUMULATIVO a propósito: cada vez que se sabe algo nuevo se re-identifica con la unión de
             * todo lo conocido, así que un evento tardío nunca lleva menos que uno temprano. Y se aplica a
             * los eventos SIGUIENTES: los de antes de saber quién es (`PageView`, `ViewContent`) no pueden
             * llevarlo, y eso no tiene arreglo — nadie sabe quién eres hasta que lo escribes.
             *
             * La normalización es la de la doc de Meta: minúsculas y sin espacios; el teléfono, solo
             * dígitos CON el código de país; el país, dos letras. Mandar `Enrique` o `+52 55…` sin
             * normalizar produce un hash que no empareja con nada, o sea el dato tirado en silencio. */
            var conocido = {};
            /* EL PÍXEL DE LA CASA, ANCLADO (31-ago-2026, residual del auditor): la primera versión tomaba
               `ps[0]` — el PRIMERO que apareciera. Si un tercero registrara su píxel antes que el nuestro,
               la identidad (hasheada) se colgaría del ajeno. Con el id anclado, regalarla es
               irrepresentable: o es el nuestro, o no se aplica. */
            var PIXEL_DE_LA_CASA = '4353163978336470';
            function idDelPixel() {
              try {
                var ps = window.fbq.getState().pixels || [];
                for (var i = 0; i < ps.length; i++) if (String(ps[i].id) === PIXEL_DE_LA_CASA) return PIXEL_DE_LA_CASA;
              } catch (_) {}
              return null;
            }
            /* Y EL REINTENTO SE RE-ARMA (31-ago-2026, residual del auditor): si el stack tarda más que el
               tope, `reintentoArmado` vuelve a false — la siguiente identifica (con o sin dato nuevo) lo
               re-arma en vez de rendirse para siempre. */
            var reintentoArmado = false;
            var identidadAplicada = false;   // la puso _reaplica: hay algo aplicado, no solo acumulado
            function armaReintento() {
              if (reintentoArmado) return;
              reintentoArmado = true;
              var tope = Date.now() + 20000;
              (function tic() {
                if (window.HP_PIXEL && window.HP_PIXEL._reaplica()) return;
                if (Date.now() < tope) return setTimeout(tic, 250);
                reintentoArmado = false;
              })();
            }
            function limpia(v) { return String(v == null ? '' : v).trim().toLowerCase(); }
            function normaliza(d) {
              var o = {};
              if (d.email) o.em = limpia(d.email);
              /* Solo dígitos y CON prefijo de país: el campo oculto del formulario ya viene en E.164
                 (`+34600…`), así que basta con quitarle todo lo que no sea número. */
              if (d.telefono) { var t = String(d.telefono).replace(/[^0-9]/g, ''); if (t.length >= 8) o.ph = t; }
              if (d.nombre) {
                var partes = limpia(d.nombre).split(/\s+/).filter(Boolean);
                if (partes.length) o.fn = partes[0];
                if (partes.length > 1) o.ln = partes.slice(1).join(' ');
              }
              if (d.pais) o.country = limpia(d.pais).slice(0, 2);
              /* `external_id` es «el mismo humano» a los dos lados. Se usa el correo tal cual porque el
                 píxel lo hashea igual que el servidor: así el id coincide sin inventar un identificador
                 nuevo que habría que guardar en algún sitio. */
              if (o.em) o.external_id = o.em;
              return o;
            }
      
            return {
              /**
               * Le dice al píxel quién es la visitante, con lo que se sepa en ese momento.
               * Devuelve true si había algo NUEVO que contar (si no, no se re-inicializa por nada).
               */
              identifica: function (datos) {
                /* SE ACUMULA AUNQUE fbq AÚN NO EXISTA (31-ago-2026, hallazgo ALTA del auditor): en la
                   tienda, window.fbq lo define el stack de píxel de Shopify DE FORMA ASÍNCRONA, y el
                   relleno de memoria corre síncrono al parsear — con `hay()` delante, la identidad de la
                   que vuelve se DESCARTABA sin acumular ni armar el reintento, y el examen no lo veía
                   porque él mismo inyectaba el stub antes de la página. Solo `enPruebas` corta en seco. */
                if (enPruebas()) return false;
                var nuevo = normaliza(datos || {});
                var cambio = false;
                for (var k in nuevo) {
                  if (nuevo[k] && conocido[k] !== nuevo[k]) { conocido[k] = nuevo[k]; cambio = true; }
                }
                /* Sin dato nuevo pero con identidad PENDIENTE de aplicar (residual del auditor): re-armar
                   en vez de rendirse — cubre al stack que tardó más que el tope del reintento. */
                if (!cambio) { if (!identidadAplicada && Object.keys(conocido).length) armaReintento(); return false; }
                /* UNA SOLA VÍA DE APLICACIÓN (31-ago-2026): la línea que llama a fbq con `conocido` vive
                   EXACTAMENTE una vez, en _reaplica — así el sabotaje que la mata mata TODOS los caminos.
                   La primera versión la duplicó aquí y el saboteador cantó 10/11: la mutación rompía una
                   copia y la identidad seguía saliendo por la otra. */
                if (window.HP_PIXEL && window.HP_PIXEL._reaplica()) return true;
                armaReintento();
                return false;
              },
              /* LA LIBRERÍA TARDA MÁS QUE LA MEMORIA (31-ago-2026, cazado por el examen del cable): el
                 relleno de retomar/memoria identifica ANTES de que `fbevents.js` cargue, y `getState` aún
                 no existe — la identidad quedaba acumulada en `conocido` pero el init con datos se perdía,
                 y el primer evento (CustomizeProduct de la que vuelve) salía anónimo. Un solo reintento
                 armado: en cuanto la librería está, se aplica TODO lo conocido, antes de que la persona
                 llegue a tocar nada. Si la librería nunca carga (bloqueador), no hay eventos tampoco. */
              _reaplica: function () {
                var pixel = idDelPixel();
                if (!pixel) return false;
                try { window.fbq('init', pixel, conocido); identidadAplicada = true; return true; } catch (_) { return false; }
              },
              /** Para el instrumento: qué campos de emparejamiento se han llegado a poner. */
              quienSabe: function () { return Object.keys(conocido); },
              /** Interés declarado. `etiqueta` = popup · libro · cuestionario (regla 7). */
              lead: function (etiqueta, extra) {
                var datos = { content_name: etiqueta, content_category: 'lead' };
                // `content_ids` acepta texto libre: ahí va de qué formulario vino, cuando se sabe.
                if (extra && extra.formId) datos.content_ids = [String(extra.formId)];
                return meta('Lead', datos, idSuelto('lead_' + etiqueta));
              },
              /** Empieza a configurar su dieta. Regla 8. */
              cuestionario: function () {
                return meta('CustomizeProduct', { content_name: 'Dieta de longevidad', content_type: 'product' }, idSuelto('cp'));
              },
              /* ── los tres del cobro · el `eventID` LO MANDA EL SERVIDOR TAMBIÉN ── */
              inicioCheckout: function (piId, valor, moneda) {
                return meta('InitiateCheckout', { value: valor, currency: moneda, content_type: 'product', num_items: 1 }, 'ic_' + piId);
              },
              tarjetaPuesta: function (piId, valor, moneda) {
                return meta('AddPaymentInfo', { value: valor, currency: moneda, content_type: 'product' }, 'api_' + piId);
              },
              /* SOLO CON EL PAGO CERRADO (H-70, 23-ago-2026).
               *
               * Los dos sitios que llaman aquí lo hacían dentro de un `if (status === 'succeeded' ||
               * status === 'processing')`, y ese `if` contestaba DOS preguntas a la vez: «¿qué le enseño a
               * la clienta?» y «¿esto es una venta?». Para la primera, `processing` sí es un sí — el cobro
               * va en camino y bloquearla sería peor. Para la segunda no: un `processing` puede acabar en
               * fallo, y entonces queda contada una compra que nunca existió, con su valor, en la analítica
               * con la que se decide cuánto invertir. (La misma forma que H-69: una condición sirviendo a
               * dos decisiones que no son la misma.)
               *
               * El `status` se exige, no se asume: sin él no se manda. Y la regla vive AQUÍ y no en los dos
               * llamadores porque hay dos caminos de éxito —el directo y la vuelta de 3DS— y el día que
               * alguien añada un tercero, este seguirá cubierto sin que nadie se acuerde.
               *
               * No se pierde la venta: el webhook manda el `Purchase` por CAPI cuando Stripe confirma, con
               * el MISMO `pur_<pi>`. Es y era la fuente garantizada; esto es el refuerzo de navegador. */
              compra: function (piId, valor, moneda, estado) {
                if (estado !== 'succeeded') return false;
                return meta('Purchase', { value: valor, currency: moneda, content_type: 'product', num_items: 1 }, 'pur_' + piId);
              },
              /** Para el instrumento: saber si el píxel está disponible sin mandar nada. */
              listo: hay,
            };
          })();
      
          /* CUSTOMIZE PRODUCT · a la PRIMERA interacción con el cuestionario, no al verlo (regla 8).
           * Ver la sección no es empezar a configurar nada — y si contara al verla, el evento diría lo
           * mismo que un scroll y no serviría para saber cuántas empiezan de verdad. Se engancha una vez,
           * en la fase de captura, para que valga también con los campos que se pintan después. */
          (function () {
            var seccion = root.getElementById('solicitar');
            if (!seccion) return;
            var yaSalio = false;
            function empezo(ev) {
              if (yaSalio) return;
              /* UN EVENTO SINTETICO NUNCA ES UNA INTERACCION (29-ago-2026). El relleno de «retomar» —desde la
                 memoria o desde el enlace del correo— dispara `input`/`change` para que la validacion y el
                 detalle de alergias reaccionen, y eso contaba aqui como «la clienta empezo el cuestionario»
                 y mandaba un evento al pixel sin que nadie tocara nada. Los eventos que fabrica el codigo
                 llegan con `isTrusted === false`; los de la persona, `true`. (Ojo: `el.click()` produce
                 eventos CONFIABLES aunque lo llame el codigo — por eso el relleno no usa click.) */
              if (ev && ev.isTrusted === false) return;
              var t = ev.target;
              if (!t || !t.matches || !t.matches('input, select, textarea')) return;
              yaSalio = true;
              if (window.HP_PIXEL) window.HP_PIXEL.cuestionario();
              seccion.removeEventListener('input', empezo, true);
              seccion.removeEventListener('change', empezo, true);
            }
            seccion.addEventListener('input', empezo, true);
            seccion.addEventListener('change', empezo, true);
          })();
      
          /* LA CASILLA DE TRANSICIÓN — IDENTIFICA A LA PERSONA; NO CUENTA UN EVENTO.
           *
           * ⚠️ ESTA CASILLA YA NO MANDA UN `Lead` A META (24-ago-2026, decisión de Enrique).
           *
           * Lo mandaba, y su razón textual para quitarlo: «no asegura que el cliente deje su email, el
           * Lead (cuestionario) está más completo». Es exacto, y hay un segundo motivo que lo refuerza:
           * la casilla está ARRIBA del correo en el recorrido, así que se marcaba con el campo aún vacío
           * y salía un `Lead` sin una sola señal de quién era — inútil para emparejar. Y quien hacía el
           * recorrido entero generaba TRES `Lead` (casilla, libro, cuestionario): una persona contada
           * tres veces en una campaña optimizada a leads.
           *
           * Lo que la casilla SÍ sigue haciendo, que era su valor de verdad: el Worker la lee al crear el
           * cobro y de ahí salen el `Lead` de Klaviyo y el alta en Newsletter, ya con el correo
           * garantizado. Eso no se ha tocado.
           *
           * Se conserva el enganche para lo otro que pediste: en cuanto haya correo, el píxel sabe QUIÉN
           * es, y todos los eventos posteriores lo llevan. Identificar no es un evento — no cuenta nada,
           * solo hace que lo que se cuente después valga más. */
          (function () {
            var casilla = root.getElementById('aceptaMarketing');
            if (!casilla) return;
            casilla.addEventListener('change', function () {
              if (!casilla.checked || !window.HP_PIXEL) return;
              var correo = (root.getElementById('c-tutor-email') || {}).value;
              if (correo) window.HP_PIXEL.identifica({ email: correo, pais: window.HP_GEO_COUNTRY });
            });
          })();
      
          /* ⚠️ EL LEAD DEL POPUP NO SE MANDA DESDE AQUÍ, Y ESTO EXPLICA POR QUÉ (23-ago-2026).
           *
           * Aquí había un listener de `klaviyoForms` que disparaba `Lead('popup')`. Lo cazó el auditor
           * externo y lo comprobé en la tienda: el tema **ya carga `klaviyo-meta-lead.js`**, que escucha
           * ESE MISMO evento y manda su propio `Lead` por navegador Y por CAPI a otro Worker. Medido en
           * el borrador con un solo envío del emergente:
           *
           *     · Lead  eid=klv-1787473027708-8qss63ms    ← el script que ya existía
           *     · Lead  eid=lead_popup_mt5jaf7impzvnw     ← el que había puesto aquí
           *
           * Dos `eventID` distintos = Meta cuenta DOS leads por cada persona. Y no se arregla igualando
           * los ids: el del script viejo ya está emparejado con su gemelo de CAPI, así que meterse en
           * medio rompería esa pareja. Sobra el nuestro, y punto.
           *
           * Consecuencia para quien lea esto buscando el evento: **el popup SÍ manda `Lead`**, solo que
           * lo manda `klaviyo-meta-lead.js` y va etiquetado con `form_id`, no con `content_name`. Si
           * algún día se quiere unificar la etiqueta con la regla 7, se toca ESE script — no se añade
           * otro evento.
           *
           * La lección: antes de añadir un evento, mirar qué manda ya el tema. Este archivo no es lo
           * único que corre en la página. */
      
          /* PERO DEL POPUP SÍ SE APRENDE QUIÉN ES (24-ago-2026, encargo de Enrique: «si llena el pop-up
           * que el píxel tome el email»).
           *
           * Escuchar para IDENTIFICAR no es lo mismo que escuchar para contar un evento. El `Lead` lo
           * sigue mandando el script del tema —aquí no se manda ninguno, esa es toda la lección de
           * arriba—, pero el correo que la persona acaba de escribir viaja en ese mismo evento y sirve
           * para que TODO lo que haga después salga identificado. No cuenta nada nuevo; hace que lo ya
           * contado valga más. */
          window.addEventListener('klaviyoForms', function (e) {
            try {
              if (!e.detail || e.detail.type !== 'submit' || !window.HP_PIXEL) return;
              var correo = (e.detail.metaData || {}).$email;
              if (correo) window.HP_PIXEL.identifica({ email: correo, pais: window.HP_GEO_COUNTRY });
            } catch (_) { /* el emergente no puede tumbar la página */ }
          });
      
      /* CUÁNDO SE APARTA EL FLOTANTE — y por qué son DOS motivos, no uno.
             ─────────────────────────────────────────────────────────────────────────────────────
             Cuatro versiones y cinco hallazgos de Enrique. Vale la pena dejar escrito el recorrido,
             porque cada versión arregló lo anterior y rompió otra cosa:
      
             v1 (15-ago) · se apartaba con un botón de COMPRA a la vista. El motivo era físico y
                  medido: tapaba el 17-18 % de cada botón en un teléfono de 390 px, y el dedo abría
                  WhatsApp en vez de pagar. Pero también había un motivo de ATENCIÓN, escrito
                  entonces: «con la compra delante, el flotante no debería competir con ella».
             v2 (19-ago) · se le añadieron las zonas donde se rellena algo. Se pasó de frenada: tomaba
                  la SECCIÓN entera como zona, y el bloque 06 mide 1.393 px con su único campo al
                  final — desaparecía durante toda la sección sin nada delante.
             v3 (19-ago) · se cambió a SOLAPE puro: apartarse solo si de verdad tapa. Arregló el
                  bloque 06 y el escritorio… y perdió el motivo de ATENCIÓN: en el móvil el flotante
                  se quedaba al lado del botón de compra sin llegar a tocarlo. Medido con golpeo
                  (elementFromPoint) en 372 paradas: no tapaba nada. Y aun así estorbaba, porque
                  competir no es lo mismo que tapar.
      
             v4 · los dos motivos, cada uno con su prueba, y la línea que los separa MEDIDA en vez de
             elegida:
      
               ¿El flotante cae DENTRO de la columna de contenido?
                 · NO  → está en el margen, no le quita sitio a nadie: no se aparta nunca.
                         (Se mide contra el CONTENIDO de la columna, descontando su relleno: los 24 px
                         de aire no son de nadie, y comparando contra la caja externa la burbuja
                         «pisaba» por 18 px y se escondía en 101 de 311 paradas de escritorio.)
                         (Es lo que pasa en escritorio: la columna mide 1.180 px centrados y el
                         flotante vive en el margen derecho. Enrique: «ahí no tenemos problemas de
                         espacio».)
                 · SÍ  → está encima de lo que se lee, y entonces se aparta por CUALQUIERA de los dos:
                         (a) ATENCIÓN · hay una acción principal a la vista de verdad (≥35 % de su
                             alto). Con la compra delante, el flotante sobra aunque no la toque.
                         (b) TAREA · la caja que envuelve a los campos que hay en pantalla, de un mismo
                             contenedor, se solapa con la suya. Ni la sección entera (v2, escondía
                             1.393 px por un campo del final) ni el campo suelto (v4, no se apartaba
                             del cuestionario): la envolvente de los campos crece donde se rellena y
                             se queda pequeña donde solo hay uno de paso.
      
             Sin `@media` y sin ancho mágico: la frontera es «¿me como la columna o no?», que el
             navegador contesta solo. Si mañana la columna se ensancha o el flotante se mueve, la
             respuesta cambia sola.
             Si el navegador no trae IntersectionObserver, no pasa nada: se queda como estaba. */
          (function () {
            var wa = root.querySelector('.wa-float');
            if (!wa || !('IntersectionObserver' in window)) return;
      
            /* LO QUE ES CHROME NO CUENTA. La barra de arriba y el modal de pago son `position:fixed`:
               viven pegados a la pantalla, no a la pagina, y nunca se cruzan con el flotante —la barra
               esta arriba, el flotante abajo—. Si contaran, el boton de la barra fija esta SIEMPRE a la
               vista tras el hero y el flotante no volveria a aparecer jamas. */
            var esChrome = function (e) {
              for (var n = e; n; n = n.parentElement) if (getComputedStyle(n).position === 'fixed') return true;
              return false;
            };
            /* TODOS los botones de marca, no solo los grandes. `.btn-grande` es un MODIFICADOR de
               `.btn`: al listar solo el modificador, el boton «Enviarme el libro» —que es `.btn` a
               secas— quedaba fuera y el flotante se le posaba al lado. Lo cazo Enrique. */
            var acciones = [].slice.call(root.querySelectorAll('.btn, .form-btn-primary, .pregunta-cta')).filter(function (e) { return !esChrome(e); });
            var campos = [].slice.call(root.querySelectorAll('input:not([type=hidden]), select, textarea')).filter(function (e) { return !esChrome(e); });
            if (!acciones.length && !campos.length) return;
      
            /* ZONAS DE TAREA — donde se esta RELLENANDO algo, no donde hay un campo suelto.
               La v2 tomaba la SECCION entera y escondia el flotante durante 1.393 px por un campo que
               estaba al final. La v4 miro los campos UNO A UNO y entonces no se apartaba del
               cuestionario, donde la clienta escribe durante seis mil pixeles. La medida que separa
               las dos cosas no es una lista ni un umbral: es CUANTO OCUPAN LOS CAMPOS dentro de su
               contenedor. Medido: en el cuestionario los campos abarcan la seccion entera; en el
               bloque 06, 49 px de 1.393 (el 4 %). Asi que la zona es la caja que ENVUELVE a los campos
               de cada contenedor — grande donde se rellena, pequena donde solo hay uno de paso. */
            /* Y cada campo cuenta con la caja de lo que la clienta TOCA, no con la del control: un
               radio es un circulito de 20 px pegado a la izquierda, asi que su envolvente no llegaba
               ni de lejos al flotante y el cuestionario asomaba en 14 de 31 paradas. Lo que se pulsa
               es su `<label>`, que ocupa la tarjeta entera. Es semantico, no un nombre de clase. */
            var cajaDe = function (c) { return c.closest('label') || c; };
            var contenedores = [];
            root.querySelectorAll('section, form').forEach(function (z) {
              var cs = campos.filter(function (c) { return z.contains(c); });
              if (cs.length) contenedores.push(cs);
            });
      
            // Conjuntos de lo que se ve AHORA. Un contador no vale: la primera ráfaga del observador
            // avisa de todo a la vez, casi todo fuera de pantalla, y lo dejaba en negativo para siempre.
            var accionesAlaVista = new Set();
            var camposAlaVista = new Set();
            var pedido = false;
      
            function cajaDelFlotante() {
              var r = wa.getBoundingClientRect();
              var b = wa.querySelector('.wa-burbuja');
              if (!b) return { left: r.left, top: r.top, right: r.right, bottom: r.bottom };
              var rb = b.getBoundingClientRect();
              return { left: Math.min(r.left, rb.left), top: Math.min(r.top, rb.top),
                       right: Math.max(r.right, rb.right), bottom: Math.max(r.bottom, rb.bottom) };
            }
      
            /* ¿El flotante pisa el CONTENIDO, o vive en el margen?
               Se mide contra la caja de contenido de la columna —descontando su relleno—, no contra su
               caja externa: la columna lleva 24 px de relleno donde no hay ni una letra, y la burbuja
               asomaba justo ahí. Con la caja externa, en escritorio salía «pisa» por 18 px de aire y el
               flotante se escondía en 101 de 311 paradas, que es justo lo que Enrique pidió quitar. */
            function pisaElContenido(f) {
              var col = root.querySelector('.container');
              if (!col) return true;                       // sin columna que medir, se asume que sí
              var c = col.getBoundingClientRect();
              var e = getComputedStyle(col);
              var izq = c.left + (parseFloat(e.paddingLeft) || 0);
              var der = c.right - (parseFloat(e.paddingRight) || 0);
              return f.right > izq && f.left < der;
            }
      
            function seTocan(a, b, holgura) {
              return a.left < b.right + holgura && a.right > b.left - holgura
                  && a.top < b.bottom + holgura && a.bottom > b.top - holgura;
            }
      
            function decide() {
              pedido = false;
              var f = cajaDelFlotante();
              if (!pisaElContenido(f)) { wa.classList.remove('oculto'); return; }
              var estorba = accionesAlaVista.size > 0;
              if (!estorba) {
                for (var i = 0; i < contenedores.length && !estorba; i++) {
                  var cs = contenedores[i], hay = false, izq = 0, arr = 0, der = 0, aba = 0;
                  /* TODOS los campos del contenedor, no solo los que asoman ahora. Filtrando por los
                     visibles, el cuestionario se partia en trozos: entre dos grupos de campos hay texto
                     de ayuda largo, ahi no habia ninguno en pantalla y el flotante reaparecia — asomaba
                     en 5 de sus 31 paradas. Un cuestionario es UNA tarea continua, no una serie de
                     campos sueltos. Y esto no revive el fallo del bloque 06, porque alli la envolvente
                     de su unico campo sigue midiendo 49 px de los 1.393 de la seccion. */
                  for (var k = 0; k < cs.length; k++) {
                    var c = cajaDe(cs[k]).getBoundingClientRect();
                    if (!c.width || !c.height) continue;
                    if (!hay) { hay = true; izq = c.left; arr = c.top; der = c.right; aba = c.bottom; }
                    else { izq = Math.min(izq, c.left); arr = Math.min(arr, c.top); der = Math.max(der, c.right); aba = Math.max(aba, c.bottom); }
                  }
                  if (hay && seTocan(f, { left: izq, top: arr, right: der, bottom: aba }, 8)) estorba = true;
                }
              }
              wa.classList.toggle('oculto', estorba);
            }
            function pide() { if (!pedido) { pedido = true; requestAnimationFrame(decide); } }
      
            // ATENCIÓN: 0.35 del alto de la acción — tiene que verse de verdad, no asomar.
            var obsAcciones = new IntersectionObserver(function (es) {
              es.forEach(function (e) { if (e.isIntersecting) accionesAlaVista.add(e.target); else accionesAlaVista.delete(e.target); });
              pide();
            }, { threshold: 0.35 });
            acciones.forEach(function (a) { obsAcciones.observe(a); });
      
            // ESTORBO: basta con que el campo asome; el solape se calcula después, caja contra caja.
            var obsCampos = new IntersectionObserver(function (es) {
              es.forEach(function (e) { if (e.isIntersecting) camposAlaVista.add(e.target); else camposAlaVista.delete(e.target); });
              pide();
            }, { threshold: 0 });
            campos.forEach(function (c) { obsCampos.observe(c); });
      
            // El observador avisa al entrar y al salir, pero no mientras algo se desplaza por dentro.
            addEventListener('scroll', pide, { passive: true });
            addEventListener('resize', pide);
            pide();
          })();
      
          // Sticky bar: aparece al pasar el hero
          const stickyBar = root.getElementById('stickyBar');
          const hero = root.querySelector('.hero');
          window.addEventListener('scroll', () => {
            const heroBottom = hero.offsetTop + hero.offsetHeight;
            if (window.scrollY > heroBottom) {
              stickyBar.classList.add('visible');
            } else {
              stickyBar.classList.remove('visible');
            }
          });
      
          // FAQ: cerrar las demás al abrir una
          root.querySelectorAll('details.faq').forEach((det) => {
            det.addEventListener('toggle', (e) => {
              if (det.open) {
                root.querySelectorAll('details.faq').forEach((other) => {
                  if (other !== det) other.removeAttribute('open');
                });
              }
            });
          });
      
          // Las tarjetas de síntomas se marcan. Es la primera acción de la página y el primer
          // "sí" pequeño: quien marca tres ya se ha respondido que su perro tiene un problema.
          (function () {
            root.querySelectorAll('.symptom-card').forEach(function (b) {
              b.addEventListener('click', function () {
                var marcado = b.getAttribute('aria-pressed') === 'true';
                b.setAttribute('aria-pressed', marcado ? 'false' : 'true');
              });
            });
          })();
      
      // La pregunta escrita en la página viaja a WhatsApp ya redactada.
          //
          // Lo que se gana: quien pulsa un enlace de WhatsApp normal aterriza en una
          // conversación vacía y ahí tiene que pensar qué escribir; muchos cierran. Escribiendo
          // aquí, en WhatsApp solo queda darle a enviar.
          //
          // Si el renglón está vacío se manda el saludo de siempre, que es lo que hacía el
          // enlace anterior: el botón nunca se queda sin hacer nada.
          (function () {
            var TELEFONO = (host.getAttribute('data-whatsapp') || '').replace(/[^0-9]/g, '');  // lo pone el tema al publicar (section.settings.whatsapp_number); el build lo mapea
            var POR_DEFECTO = 'Hola Jeanette, tengo una duda sobre la dieta personalizada de mi perro.';
      
            var campo = root.getElementById('waPregunta');
            var botonGrande = root.getElementById('waPreguntar');
            if (!campo || !botonGrande) return;
      
            function abrirWhatsApp() {
              var escrito = (campo.value || '').trim();
              var texto = escrito
                ? 'Hola Jeanette, tengo una duda sobre la dieta personalizada de mi perro: ' + escrito
                : POR_DEFECTO;
              // Se abre en pestaña nueva para no perder la página: si vuelve, sigue donde estaba.
              window.open('https://wa.me/' + TELEFONO + '?text=' + encodeURIComponent(texto), '_blank', 'noopener');
            }
      
            botonGrande.addEventListener('click', abrirWhatsApp);
            // Enter dentro del renglón, que es lo que hace cualquiera al terminar de escribir.
            campo.addEventListener('keydown', function (e) {
              if (e.key === 'Enter') { e.preventDefault(); abrirWhatsApp(); }
            });
          })();
      
      // La compuerta de los casos excluidos. Si marca que tiene una enfermedad crónica
          // diagnosticada, se esconde el botón de pagar y aparece el aviso con el WhatsApp.
          // Esconder el botón y no solo avisar es lo que la convierte en puerta: un aviso al
          // lado de un botón activo se ignora.
          (function () {
            var aviso = root.getElementById('excluido');
            var envio = root.querySelector('.form-submit');
            if (!aviso || !envio) return;
            function revisar() {
              var si = root.querySelector('input[name="enfermedad_cronica"][value="si"]');
              var excluida = !!(si && si.checked);
              aviso.hidden = !excluida;
              envio.hidden = excluida;
            }
            root.querySelectorAll('input[name="enfermedad_cronica"]').forEach(function (r) {
              r.addEventListener('change', revisar);
            });
            revisar();
          })();
      
      /* Form submit + Stripe Payment Element (arquitectura vigente 2026-05-29).
             Reemplaza el flow viejo Shopify cart/checkout (que pedia direccion obligatoria
             aunque sea producto digital) por modal in-page con Stripe Payment Element.
      
             Razon NO Embedded Checkout (Checkout Sessions API):
               - Cuenta Stripe registrada en MX no soporta Adaptive Pricing con base EUR.
               - Payment Element nos da control TOTAL de UI (sin summary fijo, sin cardholder
                 forzado, sin scroll mobile, sin selector de moneda raro al cliente).
               - Ver Pago Dietas/IMPLEMENTACION.md para detalle de la decision.
      
             Flujo:
               1) Valida form (gatherFormData)
               2) POST a /create-payment-intent (Cloudflare Worker) con idempotency key
               3) Abre modal con Stripe Payment Element (tarjeta + Apple Pay + Google Pay
                  como tabs horizontales, segun browser/device del cliente)
               4) confirmPayment directo con redirect:'if_required' (clientSecret mode: NO se
                  usa elements.submit(), eso es solo deferred mode. Ver handlePayClick). Tarjeta
                  y wallets resuelven INLINE; 3DS bancario redirige y vuelve por checkRedirectReturn
               5) Webhook Stripe -> Worker crea order en Shopify con properties + billing/shipping
               6) Pipeline dietas-pendientes la recoge igual que antes
      
             Anti-doble-cargo:
               - btn disabled instantaneo al click (anti doble-click del submit en curso)
               - reuso del client_secret en retries (no crea nuevo PaymentIntent)
               - paymentInProgress bloquea close del modal mientras Stripe procesa
               - Idempotency key UUID v4 por intento submit (Stripe garantiza 24h dedup)
               NOTA: NO usamos lock persistente (sessionStorage). Tras pagar, el botón queda
               "Pedido recibido" en memoria; un reload da formulario fresco para otra compra
               (cliente con varios perros). El doble-cargo accidental es improbable (form de
               13 campos hay que re-llenar) y el del mismo submit ya lo cubren las 2 capas de arriba.
      
             Edge case 3DS redirect (cuando el banco fuerza redirect completo, ~raro):
               - Volvemos a esta URL con ?payment_intent_client_secret=xxx
               - checkRedirectReturn() detecta y verifica via stripe.retrievePaymentIntent
               - Mostramos exito sin perder el pago */
          /* Esto va FUERA de la espera al DOM, y el motivo lo aprendi rompiendolo: al aplazar el bloque
             del pago me lleve dentro esta resolucion, y el script de multi-moneda —que corre antes— se
             quedo sin `window.HP_API_BASE`. Pedia `/geo` a `localhost`, recibia un 404, y sin pais la
             lada se quedaba en +1: el modal salia en INGLES pidiendo un ZIP code. Resolver una URL no
             necesita el DOM; solo lo necesita manejar el modal. */
          /* ═══════════════════════════════════════════════════════════════════════════════════════
             A QUE WORKER LE HABLA ESTA PAGINA (19-ago-2026)
             ═══════════════════════════════════════════════════════════════════════════════════════
             Hay dos: el de PRODUCCION, que cobra de verdad, y el de PRUEBA, que hace lo mismo con las
             llaves de test de Stripe. La misma pagina sirve para los dos — NO hay una copia del HTML
             para probar. Una copia se queda atras en el primer cambio y se acaba probando algo que ya
             no es lo que se publica.
      
             El cambio SOLO existe sirviendo la pagina desde este ordenador. En healthandpaws.com el
             parametro se ignora por completo, y eso no es cosmetica: si bastara con anadir algo a la
             direccion para que la pagina le hablara a otro servidor, cualquiera podria mandarle a una
             clienta un enlace de la tienda de verdad que cobrara a otro sitio.
             ═══════════════════════════════════════════════════════════════════════════════════════ */
          /* Se cuelga de `window` A PROPOSITO: la pagina tiene varios bloques de <script> y un `var` de
             uno no existe en el otro. Declarada asi, la resuelve el PRIMERO que se ejecute y todos los
             demas leen la misma — que es justo lo que hace falta, porque dos bloques apuntando a dos
             Workers distintos seria peor que no tener modo de prueba. */
          window.HP_API_BASE = window.HP_API_BASE || (function () {
            var enLocal = /^(localhost|127\.0\.0\.1)$/.test(location.hostname);
            var pidePrueba = enLocal && /(^|[?&])entorno=prueba(&|$)/.test(location.search);
            if (pidePrueba) console.warn('[HP] MODO PRUEBA: se le habla al Worker de test. Ningun cobro es real.');
            window.HP_PIDE_PRUEBA = pidePrueba;
            return pidePrueba
              ? 'https://hp-pago-dietas-test.ancient-surf-4570.workers.dev'
              : 'https://hp-pago-dietas.ancient-surf-4570.workers.dev';
          })();
      
          (function () {
          /* ═══════════════════════════════════════════════════════════════════════════════════════
             ESTE BLOQUE ESPERA A QUE EL HTML ESTE ENTERO (20-ago-2026)
             ═══════════════════════════════════════════════════════════════════════════════════════
             Corria en cuanto el navegador lo leia, y este <script> esta MUY POR ENCIMA del marcado del
             modal: al arrancar, `getElementById('stripeModalOverlay')` devolvia null. Todo lo que
             dependia de el —inyectar su CSS, sacarlo del Shadow DOM, guardar sus referencias— se
             saltaba en silencio, y al pulsar «Pagar» el cobro se creaba en Stripe pero el modal NO SE
             ABRIA. Sin un solo error en consola.
      
             En la tienda no pasaba: el build saca todo este JavaScript a un archivo aparte que se carga
             al final, cuando el marcado ya existe. Es decir, el fallo SOLO se ve abriendo el archivo
             fuente — y por eso llevaba ahi sin que nadie lo notara: nadie habia abierto el modal fuera
             de la tienda. Un codigo que depende de DONDE lo coloque el build es un codigo que funciona
             por suerte.
      
             Esperar al DOM no cambia nada en la tienda (alli ya estaba listo) y arregla el archivo. La
             pieza deja de depender de su posicion.
             ═══════════════════════════════════════════════════════════════════════════════════════ */
          function arrancarPago() {
            var PAYMENT_API = window.HP_API_BASE + '/create-payment-intent';
            // Stripe.js v3 evergreen (revertido de 'dahlia' 2026-05-29 porque rompia
            // deteccion Google Pay en Chrome desktop con cuenta wallet configurada).
            // Trade-off: v3 puede tener cambios breaking sin warning. Evaluar pin a una
            // version nueva (eucalyptus/etc) cuando Stripe documente compatibilidad GP.
            var STRIPE_JS_URL = 'https://js.stripe.com/v3/';
      
            // Publishable key PUBLICO (no es secreto — seguro hardcodearlo en frontend).
            // Fallback robusto (fix I2-audit): tras un redirect de wallet, Safari ITP puede
            // borrar sessionStorage; sin el pk, checkRedirectReturn no podia verificar el pago
            // y caia a un branch que asumia exito (falso positivo si el cliente cancelo).
            // Con el pk siempre disponible como constante, SIEMPRE verificamos via
            // retrievePaymentIntent. CRITICO: actualizar a pk_live_... al pasar a Live mode.
            var STRIPE_PK = 'pk_live_51TbsLcJhgjHxdcycsPke129id3h2WJlqEtQKU7GyWkhCLJz7thwtccRB4tCTMEGd90hzTucRywiHSj5nTvH5PwMm00wSgGYBMf';
      
            var btn = root.getElementById('btnSolicitarDieta');
            if (!btn) return;
            var originalLabel = btn.innerHTML; // innerHTML para conservar el <span class="js-precio"> del precio
      
            var FIELD_LABELS = {
              tutor_nombre: 'Tu nombre',
              tutor_email: 'Tu correo electrónico',
              tutor_telefono: 'Teléfono',
              enfermedad_cronica: 'Si tiene alguna enfermedad crónica grave',
              perro_raza: 'Raza',
              come_actual: 'Qué come actualmente',
              perro_nombre: 'Nombre del perro',
              sexo: 'Sexo',
              esterilizado: 'Esterilizado',
              perro_edad: 'Edad',
              perro_peso: 'Peso',
              complexion: 'Complexión',
              actividad: 'Nivel de actividad',
              condicion: 'Condición de salud',
              tieneAlergias: 'Alergias o intolerancias',
              proteinaPrincipal: 'Proteína principal'
            };
      
            // ============================================================
            // Form helpers
            // ============================================================
            function isFieldVisible(el) {
              var ff = el.closest && el.closest('.form-field');
              if (!ff) return true;
              if (ff.style && ff.style.display === 'none') return false;
              return ff.offsetParent !== null;
            }
      
            function gatherFormData() {
              // Solo los campos del cuestionario. Buscando en todo el documento se colaba el
              // correo de la sección del libro, que no tiene nada que ver con el pedido; y si
              // algún día esa sección lleva un campo obligatorio, bloquearía la compra sin que
              // nadie entendiera por qué.
              var ambito = root.getElementById('solicitar') || document;
              var named = ambito.querySelectorAll('input[name], select[name], textarea[name]');
              var data = {};
              var missing = [];
              var radios = {};
              named.forEach(function (el) {
                if (!isFieldVisible(el)) return;
                var name = el.getAttribute('name');
                var isReq = el.hasAttribute('required');
                if (el.type === 'radio') {
                  if (!radios[name]) radios[name] = { required: false, checked: null, firstEl: el };
                  if (isReq) radios[name].required = true;
                  if (el.checked) radios[name].checked = el.value;
                  return;
                }
                if (el.type === 'checkbox') {
                  if (el.checked) data[name] = el.value || 'on';
                  else if (isReq) missing.push({ name: name, el: el });
                  return;
                }
                var v = (el.value || '').trim();
                if (v) data[name] = v;
                else if (isReq) missing.push({ name: name, el: el });
              });
              for (var name in radios) {
                var info = radios[name];
                if (info.checked) data[name] = info.checked;
                else if (info.required) missing.push({ name: name, el: info.firstEl });
              }
              return { data: data, missing: missing };
            }
      
            function showFormError(msg, target) {
              var err = root.getElementById('formSubmitError');
              if (!err) {
                err = document.createElement('p');
                err.id = 'formSubmitError';
                err.style.cssText = 'color:#c0392b;font-size:14px;margin-top:12px;font-weight:600;';
                btn.parentNode.insertBefore(err, btn.nextSibling);
              }
              err.textContent = msg;
              if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            function clearFormError() {
              var err = root.getElementById('formSubmitError');
              if (err) err.remove();
            }
      
            // ============================================================
            // Stripe modal — state + refs DOM
            //
            // CRITICO: Stripe Elements NO soporta Shadow DOM. El iframe no puede
            // hacer postMessage de vuelta al parent cuando esta dentro de un shadow
            // root => evento 'ready' nunca dispara, Element se queda en skeleton.
            // Fix: al cargar, movemos el modal entero a document.body e inyectamos
            // su CSS en document.head para que se siga viendo igual.
            // ============================================================
            var stripeJsPromise = null;
            var stripe = null;
            var elements = null;
            var paymentElement = null;
            var currentFormSnapshot = null;
            var paymentInProgress = false;
            // Estado de validacion de INPUT que reporta el Element via su evento 'change'.
            // Si esta seteado, el Element YA muestra ese error inline (marca no soportada,
            // numero incompleto, etc.) -> NO debemos duplicarlo en nuestra caja. Los declines
            // de CONFIRMACION (currency_not_supported, card_declined real) NO los pinta el Element
            // en nuestro modal (verificado en vivo) -> esos SI los mostramos nosotros.
            var elementInlineError = null;
      
            // ============================================================
            // Debug instrumentation RETIRADA para produccion (2026-06-04). hpDebug queda como
            // no-op: sin panel, sin console.log, ni con ?debug=1. Se deja la funcion vacia para
            // no tocar las ~18 llamadas existentes (quedan inertes). Para re-diagnosticar a futuro,
            // ver el historial de git de este archivo.
            // ============================================================
            function hpDebug() { /* no-op (debug retirado de produccion) */ }
      
            // Aliases para bypassear el rewrite del build (document.* -> root.*)
            var DOC = window.document;
            var BODY = DOC.body;
      
            // 1) Encontrar modal en el shadow root (donde lo escribimos en HTML)
            var modal = root.getElementById('stripeModalOverlay');
      
            /* LOS COLORES DEL MODAL SE LEEN DE LA LANDING, NO SE COPIAN (20-ago-2026)
               ---------------------------------------------------------------------
               El CSS del modal es un TEXTO de JavaScript, y en la tienda el modal acaba colgando de
               `document.body`, FUERA del Shadow DOM donde viven los tokens de la landing (alli `:root`
               se convierte en `:host`). O sea que `var(--accent)` no resolveria alli, y escribir
               `#FF6B4A` a mano recrearia la copia que acabamos de eliminar: cambias el coral de la
               marca y el modal se queda con el viejo, sin que nada avise.
               La salida es leerlos AHORA —mientras el modal todavia esta dentro de la landing y los
               hereda— y escribirlos en la propia hoja del modal. Una sola fuente, y sobrevive al
               traslado. Si algun token faltara, se usa el respaldo y se GRITA por consola: un color
               equivocado en silencio es peor que uno equivocado a voces. */
            var HP_TOKENS = (function () {
              var desde = modal || DOC.documentElement;
              var cs = window.getComputedStyle(desde);
              function leer(nombre, respaldo) {
                var v = (cs.getPropertyValue(nombre) || '').trim();
                if (!v) {
                  if (window.console && console.error) {
                    console.error('[modal] falta el token ' + nombre + ' de la landing; se usa ' + respaldo +
                                  '. El modal puede haberse quedado con un color viejo.');
                  }
                  return respaldo;
                }
                return v;
              }
              return {
                accent:      leer('--accent', '#FF6B4A'),        // coral de marca — el color de la accion
                accentDark:  leer('--accent-dark', '#E0552E'),   // el canto del boton en reposo
                accentCanto: leer('--accent-canto', '#C7461F'),  // el canto cuando el fondo ya es el oscuro
                aqua:        leer('--primary-light', '#0AC1B1'),  // foco de los campos y detalles
                texto:       leer('--text', '#1A1A1A'),
                tenue:       leer('--text-muted', '#5C5C5C'),
                borde:       leer('--border', '#E5E5E5'),
                critico:     leer('--critical', '#C0392B')
              };
            })();
      
            /* Stripe valida los valores de `appearance.rules` y no admite `color-mix`, asi que el halo
               de foco se calcula aqui desde el MISMO token en vez de escribir otro rgba a mano. */
            function hpConAlfa(color, alfa) {
              var c = String(color).trim();
              var m = /^#([0-9a-f]{6})$/i.exec(c);
              if (!m) return c;                       // ya viene en rgb()/hsl(): se deja como esta
              var n = parseInt(m[1], 16);
              return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + alfa + ')';
            }
            /* VESTIR Y MOVER SON DOS COSAS DISTINTAS (20-ago-2026).
               Estaban en la MISMA condicion: «si el modal no cuelga de body, cargale la tipografia,
               inyectale el CSS y muevelo». En la tienda se cumple —la landing vive en un Shadow DOM— y
               todo funciona. Pero abriendo el archivo suelto, el modal YA cuelga de body: se saltaba el
               bloque entero, se quedaba SIN ESTILOS y aparecia aplastado a cero de alto.
               Nadie lo habia visto porque nadie habia abierto el modal fuera de la tienda. Se separan:
               los estilos van SIEMPRE (ya eran idempotentes, guardados por su id), y solo el traslado
               depende de donde este. Una pieza que unicamente se ve bien en un entorno no esta probada
               en los demas: esta sin mirar. */
            if (modal) {
              // 2a) Cargar Poppins en document.head. La landing carga Poppins via <link>
              // dentro del Shadow DOM, pero el modal vive en document.body donde Poppins
              // NO esta disponible -> mi input "Nombre titular" caia a -apple-system
              // mientras Stripe Element si tenia Poppins (lo cargo via fonts: [...]).
              // Resultado: dos fuentes distintas visualmente. Fix: cargar Poppins aqui tambien.
              if (!DOC.getElementById('hp-stripe-poppins-font')) {
                var fontLink = DOC.createElement('link');
                fontLink.id = 'hp-stripe-poppins-font';
                fontLink.rel = 'stylesheet';
                fontLink.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap';
                DOC.head.appendChild(fontLink);
              }
              // 2b) Inyectar CSS del modal en document.head (solo una vez)
              if (!DOC.getElementById('hp-stripe-modal-styles')) {
                var styleEl = DOC.createElement('style');
                styleEl.id = 'hp-stripe-modal-styles';
                styleEl.textContent = (
                  /* Los tokens que acabamos de LEER de la landing se escriben aqui, en la propia
                     hoja del modal. Es lo que hace que el traslado a document.body no le quite el
                     color: ya no depende de heredar nada. */
                  '.stripe-modal-overlay{' +
                    '--sm-accent:' + HP_TOKENS.accent + ';' +
                    '--sm-canto:' + HP_TOKENS.accentDark + ';' +
                    '--sm-canto-encima:' + HP_TOKENS.accentCanto + ';' +
                    '--sm-aqua:' + HP_TOKENS.aqua + ';' +
                    '--sm-texto:' + HP_TOKENS.texto + ';' +
                    '--sm-tenue:' + HP_TOKENS.tenue + ';' +
                    '--sm-borde:' + HP_TOKENS.borde + ';' +
                    '--sm-critico:' + HP_TOKENS.critico + ';}' +
                  '.stripe-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.55);z-index:2147483000;display:flex;align-items:flex-end;justify-content:center;padding:0;animation:smFadeIn 0.2s ease-out;font-family:Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;color:var(--sm-texto);}' +
                  '.stripe-modal-overlay[hidden]{display:none !important;}' +
                  '@keyframes smFadeIn{from{background:rgba(0,0,0,0);}to{background:rgba(0,0,0,0.55);}}' +
                  '.stripe-modal{background:white;width:100%;max-width:480px;max-height:92vh;display:flex;flex-direction:column;border-radius:16px 16px 0 0;overflow:hidden;animation:smSlideUp 0.25s ease-out;}' +
                  '@keyframes smSlideUp{from{transform:translateY(28px);opacity:0.7;}to{transform:translateY(0);opacity:1;}}' +
                  '@media(min-width:600px){.stripe-modal-overlay{align-items:center;padding:24px;}.stripe-modal{border-radius:16px;max-height:90vh;}}' +
                  /* LO OCULTO SE QUEDA OCULTO, PASE LO QUE PASE (20-ago-2026, catch de Enrique).
                     El atributo `hidden` del navegador vale MENOS que cualquier regla de clase con
                     `display`. El dia que se le puso `display:flex` a la caja del aviso —para centrar su
                     boton— dejo de esconderse: quedaba una caja rosa vacia colgada encima del boton de
                     pagar, sin texto y sin motivo.
                     Se arregla para TODO el modal y no solo para esa caja: cualquier elemento de aqui
                     dentro que lleve `hidden` desaparece, tenga el `display` que tenga. Asi el error deja
                     de ser posible en vez de quedar arreglado en un sitio — que era como estaba, con tres
                     reglas sueltas y una cuarta que faltaba. */
                  '.stripe-modal-overlay[hidden],.stripe-modal-overlay [hidden]{display:none !important;}' +
                  '.stripe-modal *{box-sizing:border-box;}' +
                  '.stripe-modal-view{display:flex;flex-direction:column;overflow:hidden;}' +
                  '.stripe-modal-view[hidden]{display:none !important;}' +
                  '.stripe-modal-header{display:flex;align-items:center;justify-content:space-between;padding:12px 20px;border-bottom:1px solid var(--sm-borde);flex-shrink:0;}' +
                  '.stripe-modal-header h3{margin:0;font-size:18px;font-weight:600;color:var(--sm-texto);}' +
                  '.stripe-modal-close{background:none;border:none;font-size:28px;line-height:1;cursor:pointer;padding:4px 10px;color:var(--sm-tenue);border-radius:4px;}' +
                  '.stripe-modal-close:hover{background:#f5f5f5;color:var(--sm-texto);}' +
                  '.stripe-modal-close:focus-visible{outline:none;box-shadow:0 0 0 3px color-mix(in srgb, var(--sm-aqua) 25%, transparent);}' +
                  '.stripe-modal-body{padding:20px 22px 22px;overflow-y:auto;-webkit-overflow-scrolling:touch;}' +
                  '.stripe-summary{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px 16px;background:color-mix(in srgb, var(--sm-aqua) 6%, transparent);border-radius:10px;margin-bottom:12px;}' +
                  '.stripe-summary-label{font-size:14px;color:var(--sm-texto);line-height:1.4;}' +
                  '.stripe-summary-price{font-size:18px;font-weight:700;color:var(--sm-texto);white-space:nowrap;}' +
                  '.stripe-loading{text-align:center;padding:32px 0;color:var(--sm-tenue);font-size:14px;}' +
                  '.stripe-loading p{margin:12px 0 0;}' +
                  '.stripe-spinner{display:inline-block;width:28px;height:28px;border:3px solid #eaeaea;border-top-color:var(--sm-aqua);border-radius:50%;animation:smSpin 0.8s linear infinite;}' +
                  '.stripe-spinner-small{width:16px;height:16px;border-width:2px;vertical-align:middle;margin-right:8px;}' +
                  '@keyframes smSpin{to{transform:rotate(360deg);}}' +
                  '.stripe-element-mount{margin-bottom:14px;min-height:0;}' +
                  '.stripe-error{display:flex;flex-direction:column;align-items:stretch;background:color-mix(in srgb, var(--sm-critico) 8%, transparent);color:var(--sm-critico);border:1px solid color-mix(in srgb, var(--sm-critico) 20%, transparent);border-radius:8px;padding:12px 14px;font-size:14px;line-height:1.4;margin-bottom:14px;}' +
                  /* El boton de la oferta de la regla 6. Secundario a proposito: la accion principal
                     del modal sigue siendo pagar, esta es una salida — mismo canto de la marca pero en
                     el rojo del aviso, para que se lea como parte del mensaje y no como otro CTA. */
                  '.stripe-error-accion{display:inline-flex;align-self:center;margin-top:2px;align-items:center;justify-content:center;min-height:40px;padding:9px 18px;font-family:inherit;font-size:14px;font-weight:700;color:white;background:var(--sm-critico);border:none;border-radius:999px;cursor:pointer;box-shadow:0 3px 0 color-mix(in srgb, var(--sm-critico) 72%, black);transition:transform 0.1s ease, box-shadow 0.18s ease;-webkit-tap-highlight-color:transparent;}' +
                  '.stripe-error-accion:hover{transform:translateY(-2px);box-shadow:0 5px 0 color-mix(in srgb, var(--sm-critico) 55%, black);}' +
                  '.stripe-error-accion:active{transform:translateY(3px);box-shadow:0 0 0 var(--sm-critico);}' +
                  '.stripe-error-accion:focus-visible{outline:3px solid var(--sm-aqua);outline-offset:3px;}' +
                  /* EL BOTON DE PAGAR = el mismo boton de la landing (.form-btn-primary), no uno
                     parecido. Los tres estados (canto en reposo, se levanta al pasar por encima, se
                     hunde al pulsar) son la firma tactil de la marca: era el UNICO boton de marca sin
                     ella, declarado como deuda en _qa-relieve.mjs. */
                  '.stripe-pay-btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;min-height:60px;padding:18px 24px;font-family:inherit;font-size:18px;font-weight:700;letter-spacing:0.01em;color:white;background:var(--sm-accent);border:none;border-radius:999px;cursor:pointer;box-shadow:0 3px 0 var(--sm-canto);transition:background 0.18s ease, transform 0.1s ease, box-shadow 0.18s ease;-webkit-tap-highlight-color:transparent;}' +
                  '.stripe-pay-btn:hover:not(:disabled){background:var(--sm-canto);transform:translateY(-2px);box-shadow:0 5px 0 var(--sm-canto-encima);}' +
                  '.stripe-pay-btn:active:not(:disabled){transform:translateY(3px);box-shadow:0 0 0 var(--sm-canto);}' +
                  '.stripe-pay-btn:disabled{opacity:0.6;cursor:default;box-shadow:none;transform:none;}' +
                  '.stripe-pay-btn:focus-visible{outline:3px solid var(--sm-aqua);outline-offset:3px;}' +
                  '.stripe-pay-btn-label,.stripe-pay-btn-spinner{display:inline-flex;align-items:center;gap:8px;}' +
                  '.stripe-pay-btn-label[hidden],.stripe-pay-btn-spinner[hidden]{display:none;}' +
                  '.stripe-trust{display:flex;align-items:center;justify-content:center;gap:6px;margin:10px 0 0;font-size:12px;color:var(--sm-tenue);text-align:center;}' +
                  '.stripe-trust svg{color:var(--sm-aqua);}' +
                  /* El margen lateral es el MISMO que el del cuerpo del pago (22 px). Tenia 24 y por eso el
                     boton de cerrar salia 4 px mas estrecho que el de pagar: invisible, pero eran dos
                     vistas del mismo modal midiendo distinto sin motivo. */
                  /* EL FONDO VERDE DE «TRANSACCION CORRECTA» (22-ago-2026, pedido de Enrique con las
                     apps de banco como referencia). El problema que habia que resolver: la landing NO
                     tiene verde —es aqua y coral—, y aqui entraban TRES a la vez (fondo de banco, verde
                     de WhatsApp y el check). Tres verdes distintos leen como un semaforo.
                     La salida: que los tres sean LA MISMA FAMILIA. El fondo es el tinte mas claro, el
                     check el tono medio y el de WhatsApp su verde propio —que cae en el mismo tono, 142
                     contra 152 grados— asi que la pantalla lee UN verde, no tres. El coral queda como el
                     unico contraste, que es exactamente donde tiene que ir la mirada al cerrar. */
                  '.stripe-modal-success{padding:32px 22px 28px;text-align:center;background:#E9F7EF;--sm-verde:#149E5B;--sm-verde-canto:#0E7442;}' +
                  '.stripe-success-icon{margin-bottom:16px;}' +
                  '.stripe-modal-success h3{margin:0 0 16px;font-size:22px;font-weight:700;color:var(--sm-texto);}' +
                  '.stripe-modal-success p{margin:0 0 12px;font-size:15px;line-height:1.55;color:var(--sm-texto);}' +
                  '.stripe-modal-success p:last-of-type{margin-bottom:22px;}' +
                  /* EL BOTON DE CERRAR HABLA EL IDIOMA DE LA LANDING (21-ago-2026, catch de Enrique).
                     Era un rectangulo de radio 10 con texto de peso 600: no se parecia a nada de la
                     pagina. Ahora lleva la forma y el TACTO de los botones de marca —pildora, Poppins
                     700, el canto solido que se hunde al pulsar— pero en clave neutra, no en coral.
                     El coral significa «avanza, compra» en toda la landing, y esta pantalla es la del
                     pago YA hecho: un boton identico al de «Pagar 149 EUR» justo debajo de «Pago
                     recibido» se puede leer como «paga otra vez». La forma es la que da la pertenencia;
                     el color es el que dice la jerarquia.
                     LA CAJA ES LA DEL BOTON DE PAGAR (21-ago, segunda pasada de Enrique): mismo ancho
                     completo y mismo alto de 60. Lo cenii a su texto porque creí que ocupar todo era un
                     accidente del contenedor flex — no lo era: en un modal la accion va a lo ancho, y
                     esa es la caja de la landing. El examen ya no lo mide contra un numero mio: lo
                     compara CONTRA el boton de pagar. */
                  /* WhatsApp: su verde de marca (#25D366) y su relieve, igual de solido que los botones
                     de la landing. Es un enlace, no un boton, porque abre otra app: se estiliza como boton
                     pero mantiene su semantica — quien navegue con teclado o lector lo oye como enlace. */
                  /* MENOS PESO QUE EL DE CERRAR (22-ago-2026, pedido de Enrique). Antes era gemelo del coral
                     —mismo ancho completo, 60 px de alto, 16 px de letra— y los dos se disputaban la mirada.
                     Ahora se encoge a su contenido, 46 px y letra de 14: sigue siendo el verde de WhatsApp y
                     sigue pulsandose bien con el dedo (46 pasa del minimo de 44), pero ya es lo segundo. */
                  '.stripe-success-ayuda{margin:18px 0 10px;font-size:13.5px;line-height:1.5;color:var(--sm-tenue);}' +
                  /* DISCRETO PERO BOTON (22-ago-2026, dos catches de Enrique: «que no contacten por
                     cualquier cosa y sea unicamente para ajustes o dudas», y luego «no le quites el relieve,
                     para que todavia parezca boton»). El primer intento le quito el canto y con el se fue lo
                     que lo hacia legible COMO boton: quedaba una pastilla dibujada. La discrecion tenia que
                     venir del TAMANO y del contorno, no de quitarle el idioma de la casa. Asi que conserva su
                     canto solido, mas fino que el del principal (2 px contra 3), en el mismo verde del borde
                     — que es como ya se resolvia el boton de contorno de esta landing. El verde del texto es mas oscuro que el de WhatsApp a proposito — #25D366
                     sobre blanco da 1.98:1, muy lejos del 4.5 que pide AA en letra pequena. Se calculo la
                     familia hasta encontrar el que pasa: #0F7A40 da 5.41:1 sobre blanco (y 4.90:1 sobre el
                     fondo verde, por si algun dia el boton pierde el suyo) y sigue leyendose como WhatsApp.
                     El primer intento fue #128C4A y se quedo en 4.31:1 — por debajo. Medido, no supuesto. 38 px es lo mas bajo que se puede sin bajar del minimo tactil
                     de 44 contando su margen: el area pulsable real sigue siendo comoda. */
                  '.stripe-success-wa{display:inline-flex;align-items:center;justify-content:center;gap:7px;min-height:38px;padding:9px 16px;margin:0 auto 20px;font-family:inherit;font-size:13px;font-weight:700;letter-spacing:0.01em;color:#0F7A40;text-decoration:none;background:#fff;border:1.5px solid #25D366;border-radius:999px;cursor:pointer;box-shadow:0 2px 0 #25D366;transition:background 0.18s ease, transform 0.1s ease, box-shadow 0.18s ease;-webkit-tap-highlight-color:transparent;}' +
                  '.stripe-success-wa:hover{background:#F0FBF4;transform:translateY(-1px);box-shadow:0 3px 0 #25D366;}' +
                  '.stripe-success-wa:active{background:#DFF5E7;transform:translateY(2px);box-shadow:0 0 0 #25D366;}' +
                  '.stripe-success-wa:focus-visible{outline:3px solid var(--sm-verde-canto);outline-offset:3px;}' +
                  /* CIERRE EN CORAL CON RELIEVE (22-ago-2026): «manda el de cerrar», dijo Enrique. Lleva el
                     mismo lenguaje que el boton principal de la landing —coral, canto solido, 999px, 60px—
                     asi que la mirada cae ahi y no en el verde. Blanco con borde lo dejaba de segundo. */
                  '.stripe-success-close{display:flex;width:100%;align-items:center;justify-content:center;gap:8px;min-height:60px;padding:18px 24px;font-family:inherit;font-size:16px;font-weight:700;letter-spacing:0.01em;color:#fff;background:var(--sm-accent);border:none;border-radius:999px;cursor:pointer;box-shadow:0 3px 0 var(--sm-canto);transition:transform 0.1s ease, box-shadow 0.18s ease;-webkit-tap-highlight-color:transparent;}' +
                  '.stripe-success-close:hover{transform:translateY(-2px);box-shadow:0 5px 0 var(--sm-canto);}' +
                  '.stripe-success-close:active{transform:translateY(3px);box-shadow:0 0 0 var(--sm-canto);}' +
                  '.stripe-success-close:focus-visible{outline:3px solid var(--sm-aqua);outline-offset:3px;}' +
                  '.stripe-success-list{text-align:left;list-style-position:inside;padding:0;margin:0 auto 14px;max-width:380px;font-size:15px;line-height:1.55;color:var(--sm-texto);}' +
                  '.stripe-success-list li{margin-bottom:4px;}' +
                  /* ── MODAL COMPACTO EN TELEFONO (8-sep-2026, catch de Enrique con su iPhone 14 Pro) ──
                   *
                   * Con los meses sin intereses encendidos el modal crecio y en su telefono aparecio
                   * SCROLL: el boton de pagar quedaba debajo del pliegue. Lo traicionero es que la caja
                   * del modal si cabia, asi que no se veia desbordado — solo faltaba el boton.
                   *
                   * Y mi instrumento decia que cabia porque medía contra 852 px, el alto NOMINAL del
                   * aparato. Safari se queda con la barra de direccion y la de herramientas: a la pagina
                   * le quedan ~659. Medir contra el alto del telefono en vez de contra el visible es
                   * medir un telefono que no existe.
                   *
                   * De los 747 px que medía, 481 son el iframe de Stripe —no es nuestro para recortar—.
                   * Esto recorta ~53 px de LO NUESTRO: cabecera, cuerpo, resumen, boton y la nota de
                   * pago seguro. Nada de contenido se va; se aprieta el aire.
                   *
                   * Solo por debajo de 600 px: en escritorio el modal va holgado y apretarlo alli seria
                   * pagar un precio sin comprar nada. */
                  '@media(max-width:599px){' +
                    '.stripe-modal-header{padding:8px 16px;}' +
                    '.stripe-modal-header h3{font-size:17px;}' +
                    /* Se encoge por tipografia y relleno, no fijandole caja: la ✕ es texto, y darle
                     * `width/height` la descentraria sin ganar nada. 28 + 4 = 32 px de alto. */
                    '.stripe-modal-close{font-size:24px;padding:2px 8px;}' +
                    '.stripe-modal-body{padding:14px 16px 16px;}' +
                    '.stripe-summary{padding:9px 14px;margin-bottom:8px;}' +
                    '.stripe-element-mount{margin-bottom:10px;}' +
                    '.stripe-pay-btn{min-height:52px;padding:13px 20px;}' +
                    '.stripe-trust{margin-top:6px;font-size:11px;}' +
                    /* LA PANTALLA DE EXITO VIAJA CON EL CUERPO DEL PAGO, o se rompe un invariante que ya
                     * existia: «el boton de cerrar tiene la MISMA caja que el de pagar» (revision 7, a
                     * peticion de Enrique). Al compactar solo el cuerpo, el relleno lateral quedo en 16
                     * contra 22 y los botones en 52 contra 60: 349x60 frente a 361x52. Lo cazo el propio
                     * examen del modal en la misma corrida, que es exactamente para lo que esta. */
                    '.stripe-modal-success{padding:24px 16px 20px;}' +
                    '.stripe-success-close{min-height:52px;padding:13px 20px;}' +
                  '}'
                );
                DOC.head.appendChild(styleEl);
              }
              // 3) Mover el modal a document.body — ESTO si depende de donde viva: solo hay que
              //    sacarlo cuando esta dentro del Shadow DOM. Moverlo estando ya en body seria
              //    reinsertarlo en cada apertura y perder su estado.
              if (modal.parentElement !== BODY) {
                BODY.appendChild(modal);
                hpDebug('modal migrated to document.body (shadow DOM workaround)');
              }
            }
      
            // Refs SIEMPRE relativos al modal (sirve igual en shadow o en body)
            var modalCloseBtn = modal ? modal.querySelector('#stripeModalClose') : null;
            var modalErrorEl = modal ? modal.querySelector('#stripeError') : null;
            var modalLoadingEl = modal ? modal.querySelector('#stripeLoading') : null;
            var modalElementMount = modal ? modal.querySelector('#stripeElementMount') : null;
            var modalPayBtn = modal ? modal.querySelector('#stripePayBtn') : null;
            var modalPayBtnLabel = modalPayBtn ? modalPayBtn.querySelector('.stripe-pay-btn-label') : null;
            var modalPayBtnSpinner = modalPayBtn ? modalPayBtn.querySelector('.stripe-pay-btn-spinner') : null;
            var modalPayBtnAmount = modal ? modal.querySelector('#stripePayBtnAmount') : null;
            var modalSummaryPerro = modal ? modal.querySelector('#stripeSummaryPerro') : null;
            var modalSummaryPrice = modal ? modal.querySelector('#stripeSummaryPrice') : null;
            var viewPayment = modal ? modal.querySelector('#stripeViewPayment') : null;
            var viewSuccess = modal ? modal.querySelector('#stripeViewSuccess') : null;
            var successName = modal ? modal.querySelector('#successCustomerName') : null;
            var successPerro = modal ? modal.querySelector('#successPerroName') : null;
            var successEmail = modal ? modal.querySelector('#successCustomerEmail') : null;
            var successCloseBtn = modal ? modal.querySelector('#stripeSuccessClose') : null;
      
            function loadStripeJs() {
              if (stripeJsPromise) return stripeJsPromise;
              stripeJsPromise = new Promise(function (resolve, reject) {
                if (window.Stripe) return resolve(window.Stripe);
                var s = document.createElement('script');
                s.src = STRIPE_JS_URL;
                s.async = true;
                s.onload = function () {
                  if (window.Stripe) resolve(window.Stripe);
                  else reject(new Error('Stripe.js no se inicializó correctamente'));
                };
                s.onerror = function () { reject(new Error('No se pudo cargar Stripe.js (revisa tu conexión)')); };
                document.head.appendChild(s);
              });
              return stripeJsPromise;
            }
      
            // Multi-currency: locale del navegador + currency del backend. Monedas zero-decimal
            // (CLP/PYG/JPY...) NO se dividen entre 100 (el backend ya las manda en unidad mayor).
            var HP_ZERO_DECIMAL = { clp:1,pyg:1,jpy:1,krw:1,vnd:1,ugx:1,isk:1,huf:1,twd:1,bif:1,clf:1,djf:1,gnf:1,kmf:1,mga:1,rwf:1,vuv:1,xaf:1,xof:1,xpf:1 };
      
            /* El importe en unidad MAYOR, que es lo que espera Meta en `value`. No es «dividir entre
               cien»: en las monedas sin céntimos el importe YA viene en unidad mayor. Vive en una función
               porque se necesita en tres sitios distintos, y tres copias de esta regla acabarían
               discrepando justo en las dos monedas donde nadie mira. */
            function hpValorMayor(amount, currency) {
              var cur = String(currency || 'eur').toLowerCase();
              return HP_ZERO_DECIMAL[cur] ? (amount || 0) : (amount || 0) / 100;
            }
            function formatPrice(amount, currency) {
              var cur = (currency || 'eur').toLowerCase();
              var zero = !!HP_ZERO_DECIMAL[cur];
              var major = zero ? amount : amount / 100;
              var locale = navigator.language || 'es-ES';
              try {
                return new Intl.NumberFormat(locale, {
                  style: 'currency',
                  currency: cur.toUpperCase(),
                  minimumFractionDigits: 0,
                  maximumFractionDigits: zero ? 0 : 2
                }).format(major);
              } catch (_) {
                return major.toFixed(zero ? 0 : 2) + ' ' + cur.toUpperCase();
              }
            }
      
            function lockForm(lock) {
              var formInner = root.querySelector('.form-inner');
              if (!formInner) return;
              if (lock) formInner.setAttribute('inert', '');
              else formInner.removeAttribute('inert');
            }
      
            function showModal() {
              if (!modal) return;
              modal.removeAttribute('hidden');
              document.body.style.overflow = 'hidden';
              lockForm(true);
              if (viewPayment) viewPayment.removeAttribute('hidden');
              if (viewSuccess) viewSuccess.setAttribute('hidden', '');
            }
      
            function hideModal() {
              if (!modal) return;
              modal.setAttribute('hidden', '');
              document.body.style.overflow = '';
              lockForm(false);
              // Limpiar Stripe Element para evitar state stale en proximas aperturas
              if (paymentElement) {
                try { paymentElement.unmount(); } catch (_) {}
                paymentElement = null;
              }
              elements = null;
            }
      
            function showModalError(msg) {
              if (!modalErrorEl) return;
              modalErrorEl.textContent = msg;
              modalErrorEl.removeAttribute('hidden');
            }
            /* REGLA 6 (Enrique, 20-ago-2026): cuando el banco rechaza por la MONEDA, decirselo con esas
               palabras y ofrecerle volver a la de su pais.
               El mensaje crudo de Stripe para este caso —«Tu tarjeta ha sido rechazada»— es
               literalmente falso: la tarjeta esta bien, lo que no admite el banco es cobrar en esa
               divisa. Alguien que ve «rechazada» cierra la pagina y se va; alguien que lee «tu banco no
               admite pagos en euros, puedes pagar en pesos» pulsa el boton. Por eso no basta con
               nombrarlo: hay que ofrecer el cambio ahi mismo.
               Se construye con nodos, no con innerHTML: el nombre de la moneda sale de datos y no vale
               la pena abrir esa puerta. */
            function showModalErrorConOferta(msg, etiqueta, accion) {
              if (!modalErrorEl) return;
              modalErrorEl.textContent = '';
              var texto = DOC.createElement('p');
              texto.style.margin = '0 0 10px';
              texto.textContent = msg;
              modalErrorEl.appendChild(texto);
              if (etiqueta && accion) {
                var b = DOC.createElement('button');
                b.type = 'button';
                b.className = 'stripe-error-accion';
                b.textContent = etiqueta;
                b.addEventListener('click', accion);
                modalErrorEl.appendChild(b);
              }
              modalErrorEl.removeAttribute('hidden');
            }
      
            /* El nombre de la moneda en cristiano. «tu banco no admite pagos en EUR» se lee como un
               codigo de error; «en euros» se lee como una frase. Si el navegador no sabe traducirlo,
               cae al codigo antes que quedarse sin decir nada. */
            function nombreDeMoneda(cur) {
              var c = String(cur || '').toUpperCase();
              try { return new Intl.DisplayNames(['es'], { type: 'currency' }).of(c) || c; }
              catch (e) { return c; }
            }
      
            /* La moneda del pais donde ESTA la clienta, segun la geolocalizacion. Sale del mismo mapa
               que sirve el Worker (window.HP_PAISES_POR_MONEDA), no de una lista aparte. */
            function monedaDeSuPais() {
              var pais = window.HP_GEO_COUNTRY || '';
              var mapa = window.HP_PAISES_POR_MONEDA || {};
              var cur = mapa[pais];
              if (!cur || !window.HP_PRICES || !window.HP_PRICES[cur]) return null;
              if (cur === (window.HP_SELECTED_CURRENCY || 'eur')) return null;   // ya esta en la suya
              return cur;
            }
      
            function clearModalError() {
              if (!modalErrorEl) return;
              modalErrorEl.textContent = '';
              modalErrorEl.setAttribute('hidden', '');
            }
      
            // state: 'idle' | 'processing' | 'disabled'
            function setPayBtnState(state) {
              if (!modalPayBtn) return;
              if (state === 'processing') {
                modalPayBtn.disabled = true;
                if (modalPayBtnLabel) modalPayBtnLabel.hidden = true;
                if (modalPayBtnSpinner) modalPayBtnSpinner.hidden = false;
              } else {
                modalPayBtn.disabled = (state === 'disabled');
                if (modalPayBtnLabel) modalPayBtnLabel.hidden = false;
                if (modalPayBtnSpinner) modalPayBtnSpinner.hidden = true;
              }
            }
      
            /* LAS COOKIES DE META, PARA QUE EL SERVIDOR TAMBIÉN SEPA EMPAREJAR (24-ago-2026).
             *
             * `_fbp` identifica el navegador y `_fbc` guarda de qué anuncio vino. Según la propia doc de
             * la Conversions API son los dos identificadores que NO se hashean, y son los que mejor
             * emparejan — mejor incluso que el correo, porque son exactos.
             *
             * El píxel del navegador los manda solo; el Worker no los había visto nunca, así que sus
             * eventos de servidor —`InitiateCheckout`, `AddPaymentInfo` y sobre todo `Purchase`, que es la
             * fuente GARANTIZADA de la compra— llegaban a Meta sin ellos. Viajan en la llamada que ya se
             * hace al crear el cobro: ni una petición más.
             *
             * Se leen del `document.cookie` en vez de pedírselas al píxel porque el píxel no las expone,
             * y porque así siguen funcionando aunque un día cambie de versión. */
            function hpCookiesDeMeta() {
              var salida = {};
              try {
                var trozos = String(document.cookie || '').split(';');
                for (var i = 0; i < trozos.length; i++) {
                  var t = trozos[i].trim();
                  if (t.indexOf('_fbp=') === 0) salida.fbp = t.slice(5);
                  else if (t.indexOf('_fbc=') === 0) salida.fbc = t.slice(5);
                }
              } catch (_) { /* sin cookies se sigue igual: el correo hace de identificador */ }
              return salida;
            }
      
            async function openStripeModal(formData) {
              currentFormSnapshot = formData;
              clearModalError();
              if (modalElementMount) {
                modalElementMount.innerHTML = '';
                modalElementMount.style.display = '';  // reset: checkRedirectReturn pudo dejarlo en 'none'
              }
              if (modalLoadingEl) modalLoadingEl.style.display = 'block';
              setPayBtnState('disabled');
      
              if (modalSummaryPerro) modalSummaryPerro.textContent = formData.perro_nombre || 'tu perro';
      
              // Pre-cargar el precio en la moneda ya seleccionada para que el modal abra SIN
              // parpadeo EUR→local. Usa el mismo formatPrice + el precio server-authoritative
              // (HP_PRICES); al resolver el PaymentIntent el valor coincide → no se percibe cambio.
              var preCur = window.HP_SELECTED_CURRENCY || 'eur';
              var preAmt = window.HP_PRICES ? window.HP_PRICES[preCur] : null;
              if (typeof preAmt === 'number') {
                var prePrice = formatPrice(preAmt, preCur);
                if (modalSummaryPrice) modalSummaryPrice.textContent = prePrice;
                if (modalPayBtnAmount) modalPayBtnAmount.textContent = prePrice;
              }
      
              showModal();
      
              try {
                // Carga paralela: Stripe.js + crear PaymentIntent
                var stripeJsLoad = loadStripeJs();
                // Idempotency key: UUID v4 unico por intento de submit. Si la red lagea y el
                // browser reintenta el POST automaticamente, Stripe devuelve el mismo PaymentIntent
                // en lugar de crear duplicados. Cliente puede cerrar modal y reabrir -> nuevo UUID
                // (intencional: cada apertura de modal es un intento logico distinto).
                var idempotencyKey = (window.crypto && window.crypto.randomUUID)
                  ? window.crypto.randomUUID()
                  : ('hp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 11));
                var intentRes = await fetch(PAYMENT_API, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  /* `pagina`: en que pagina vive ESTE formulario (origen + ruta, sin query ni ancla). El
                     Worker la usa para armar el enlace «Terminar mi pedido» de los correos de carrito
                     abandonado, y la valida contra su lista cerrada. Se manda desde aqui porque la landing
                     es la unica que lo sabe: el navegador recorta el Referer al origen en cross-origin, asi
                     que leerlo del Referer mandaba a todo el mundo a la portada (auditoria, 29-ago-2026). */
                  body: JSON.stringify(Object.assign({}, formData, { idempotency_key: idempotencyKey, currency: (window.HP_SELECTED_CURRENCY || ''), pay_test_token: (window.HP_PAY_TEST || ''), pixel_navegador: (window.HP_PIXEL && window.HP_PIXEL.listo()) ? 'vivo' : 'mudo', pagina: location.origin + location.pathname }, hpCookiesDeMeta()))
                });
      
                if (!intentRes.ok) {
                  var detail = '';
                  try {
                    var errJson = await intentRes.json();
                    detail = errJson.errors ? errJson.errors.join('; ') : (errJson.message || errJson.error || '');
                  } catch (_) {}
                  throw new Error('Hubo un problema preparando el pago. ' + (detail ? '(' + detail + ')' : 'Vuelve a intentarlo en unos segundos.'));
                }
      
                var intent = await intentRes.json();
                if (!intent.client_secret) throw new Error('Respuesta inválida del servidor de pagos');
      
                /* EL ID DEL PAGO, que es tambien el id de deduplicacion con el servidor.
                   El Worker ya mando `InitiateCheckout` por CAPI con `ic_<pi>`; aqui sale el hermano de
                   navegador con el MISMO id, que es lo que hace que Meta cuente uno solo. Sale del propio
                   client_secret (`pi_XXX_secret_YYY`), asi que no hay que pedirlo aparte. */
                var hpPiId = String(intent.client_secret).split('_secret_')[0];
                var hpMoneda = String(intent.currency || 'eur').toLowerCase();
                var hpValor = hpValorMayor(intent.amount, hpMoneda);
                if (window.HP_PIXEL) {
                  /* AQUÍ SE SABE TODO, así que aquí se identifica con todo (encargo de Enrique: «si
                     completa la información de pago que el píxel tome Nombre, Teléfono, Email»).
                     Va ANTES de los eventos: si se identificara después, el `InitiateCheckout` y el
                     `Lead` de esta misma tanda saldrían anónimos y serían justo los que más falta hace
                     emparejar. El teléfono viene del campo oculto en formato internacional, que es el
                     único que Meta puede casar. */
                  window.HP_PIXEL.identifica({
                    email: (formData && formData.tutor_email) || '',
                    telefono: (formData && formData.tutor_telefono) || '',
                    nombre: (formData && formData.tutor_nombre) || '',
                    pais: window.HP_GEO_COUNTRY,
                  });
                  window.HP_PIXEL.inicioCheckout(hpPiId, hpValor, hpMoneda.toUpperCase());
                  /* LEAD · cuestionario — la tercera etiqueta de la regla 7. Aquí es donde ha ENTREGADO
                     sus datos de contacto, que es lo que un `Lead` significa para Meta; empezar a
                     rellenarlo es otra cosa y ya tiene su evento (`CustomizeProduct`).
                     UNA VEZ POR VISITA, no por apertura del modal (23-ago, hallazgo del auditor): cada
                     apertura crea un PaymentIntent nuevo a propósito, y el propio código REABRE el modal
                     solo tras un `currency_not_supported` — así que el flujo previsto generaba el segundo
                     lead él solito. El id es aleatorio, así que el dedup de `HP_PIXEL` no podía frenarlo:
                     la misma persona son un lead, no dos. */
                  if (!window.HP_LEAD_CUESTIONARIO_YA) {
                    window.HP_LEAD_CUESTIONARIO_YA = true;
                    window.HP_PIXEL.lead('cuestionario');
                  }
                }
      
                // Persistir publishable_key para el caso de redirect 3DS (volveriamos a esta URL)
                try { sessionStorage.setItem('hpStripePk', intent.publishable_key); } catch (_) {}
      
                var formattedPrice = formatPrice(intent.amount, intent.currency);
                if (modalSummaryPrice) modalSummaryPrice.textContent = formattedPrice;
                if (modalPayBtnAmount) modalPayBtnAmount.textContent = formattedPrice;
      
                var StripeCtor = await stripeJsLoad;
                stripe = StripeCtor(intent.publishable_key);
      
                // Pre-determinar el pais del billing en base al selector de telefono del form
                // (asi el dropdown "Country" del Element matchea lo que el cliente eligio).
                var phoneFlagEl = root.getElementById('phoneCountryFlag');
                var billingCountry = phoneFlagEl && phoneFlagEl.alt ? phoneFlagEl.alt : 'MX';
                hpDebug('billing country default: ' + billingCountry);
      
                /* ═══════════════════════════════════════════════════════════════════════════════
                   EL IDIOMA DEL MODAL SALE DE LA LADA, Y DE NADA MAS (20-ago-2026)
                   ═══════════════════════════════════════════════════════════════════════════════
                   Decision de Enrique, y tiene fundamento: Stripe pide CAMPOS DISTINTOS segun el pais
                   —ZIP en EE.UU., CAP en Italia, codigo postal en Espana— asi que forzar un idioma
                   ajeno significaria traducir mal terminos que son propios de ese pais. Que hable el
                   idioma del pais de la lada es lo unico coherente.
      
                   La tabla anterior tenia SIETE entradas y todo lo demas caia en «espanol». Vendemos en
                   20 paises de la eurozona: una clienta holandesa, polaca, griega, finlandesa, croata,
                   eslovaca, letona, lituania, estonia, chipriota o maltesa recibia el modal EN ESPANOL.
                   Once de veinte. Es la misma clase de fallo de siempre — una lista escrita a mano que
                   muestrea sin querer mientras la lista de paises que aceptamos crece por otro lado.
      
                   Ahora estan los 40 paises que el Worker acepta, y los codigos salen de la lista
                   OFICIAL de Stripe (docs.stripe.com/js/appendix/supported_locales, leida hoy). De
                   paso: `es-ES` y `pt-PT` NO existen en esa lista y el codigo los usaba. Funcionaban
                   por indulgencia de Stripe, no porque fueran validos; los correctos son `es` y `pt`.
      
                   Lo que NO esta en la tabla cae en `auto` —que Stripe lo deduzca del navegador— y no
                   en espanol. Imponer el nuestro es justo el defecto que esto viene a arreglar.
                   ═══════════════════════════════════════════════════════════════════════════════ */
                var IDIOMA_POR_PAIS = {
                  // Eurozona, los 20
                  ES: 'es',  DE: 'de',  FR: 'fr',  IT: 'it',  PT: 'pt',  NL: 'nl',  BE: 'nl',
                  AT: 'de',  IE: 'en-GB', FI: 'fi', GR: 'el', SK: 'sk', SI: 'sl', LU: 'fr',
                  LV: 'lv',  LT: 'lt',  EE: 'et',  CY: 'el',  MT: 'mt',  HR: 'hr',
                  // Resto de Europa y Norteamerica
                  GB: 'en-GB', US: 'en', CA: 'en',
                  // Latinoamerica: espanol de la region, no de Espana — no es lo mismo
                  MX: 'es-419', AR: 'es-419', CO: 'es-419', CL: 'es-419', PE: 'es-419',
                  UY: 'es-419', BO: 'es-419', EC: 'es-419', PY: 'es-419', GT: 'es-419',
                  HN: 'es-419', SV: 'es-419', NI: 'es-419', CR: 'es-419', PA: 'es-419',
                  DO: 'es-419', PR: 'es-419', VE: 'es-419', CU: 'es-419',
                  BR: 'pt-BR',
                };
                var billingLocale = IDIOMA_POR_PAIS[billingCountry] || 'auto';
                hpDebug('element locale: ' + billingLocale);
      
                elements = stripe.elements({
                  clientSecret: intent.client_secret,
                  locale: billingLocale,
                  // Cargamos Poppins dentro del iframe de Stripe para que sus campos
                  // (Card number, Caducidad, CVC, Country) se vean en la misma tipografia
                  // que el resto del modal. Sin esto, Stripe usa system fonts.
                  fonts: [
                    { cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap' }
                  ],
                  appearance: {
                    theme: 'stripe',
                    // Labels fijas arriba (no floating) — preferencia visual del proyecto.
                    /* LOS COLORES SALEN DE LOS MISMOS TOKENS QUE EL RESTO DEL MODAL (20-ago-2026).
                       Antes estaban escritos a mano aqui: eran una TERCERA copia de la paleta, ademas
                       de la hoja de la pagina y la inyectada. Con esto, cambiar el coral o el aqua de
                       la marca mueve las tres superficies a la vez, incluido lo que se pinta DENTRO
                       del iframe de Stripe, que es donde nadie mira. */
                    variables: {
                      colorPrimary: HP_TOKENS.aqua,
                      colorBackground: '#ffffff',
                      colorText: HP_TOKENS.texto,
                      colorDanger: HP_TOKENS.critico,
                      fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                      fontSizeBase: '16px', // CRITICO: >=16px evita auto-zoom en iOS Safari al hacer focus en input
                      borderRadius: '8px',   // el de los campos de la landing, medido; el boton usa pildora
                      /* HOLGURA PARA LOS ROTULOS DE DOS COLUMNAS (20-ago-2026, catch de Enrique).
                         «Vencimiento» y «Codigo de seguridad» comparten fila. Medido dentro del iframe:
                         en es-419 (Mexico, Colombia, Argentina, Chile, Peru) el rotulo compacto que
                         Stripe pone tras intentar el cobro —«Vencimiento (MM/AA)»— pide 168 px y la
                         columna daba 167. UN pixel: partia en dos lineas y dejaba su campo 17 px mas
                         abajo que el del CVC.
                         No se puede arreglar igualando alturas: la API de appearance no admite
                         `minHeight` ni `whiteSpace` en `.Label`. Lo unico posible es que QUEPA, asi que
                         se le da sitio por las dos vias: menos hueco entre columnas y el rotulo un punto
                         mas pequenio. La holgura resultante se MIDE por idioma en _qa-modal.mjs; no se
                         confia en que un numero elegido hoy siga sirviendo. */
                      gridColumnSpacing: '6px',
                      spacingUnit: '5px'  // 5px (>default 4) da respiro entre campos. Modal Payment
                                          // Element es corto (sin selector moneda, sin Link) -> sobra
                                          // espacio vertical, no causa scroll ni en mobile.
                    },
                    /* El campo de tarjeta = el campo de la landing, medido en el navegador:
                       borde 1,5 px del gris de marca, 13/16 de relleno, y al enfocar el borde aqua
                       con su halo al 12 %. Sin esto, dentro del iframe seguia el campo por defecto de
                       Stripe y el salto se notaba justo en el paso del dinero. */
                    rules: {
                      '.Input': {
                        border: '1.5px solid ' + HP_TOKENS.borde,
                        padding: '13px 16px',
                        boxShadow: 'none'
                      },
                      '.Input:focus': {
                        border: '1.5px solid ' + HP_TOKENS.aqua,
                        boxShadow: '0 0 0 3px ' + hpConAlfa(HP_TOKENS.aqua, 0.12)
                      },
                      '.Input--invalid': {
                        border: '1.5px solid ' + HP_TOKENS.critico,
                        boxShadow: 'none'
                      },
                      '.Label': {
                        color: HP_TOKENS.tenue,
                        fontWeight: '500',
                        fontSize: '14px'   // ver la nota de gridColumnSpacing: es parte del mismo arreglo
                      }
                    }
                  }
                });
      
                paymentElement = elements.create('payment', {
                  // Layout 'tabs': Tarjeta + Apple Pay + Google Pay como tabs horizontales arriba.
                  // Mas compacto y elegante que accordion para 2-3 payment methods.
                  // El Payment Element auto-muestra wallets como tabs cuando hay automatic_payment_methods
                  // y el browser tiene wallet configurado (Apple Pay en Safari, Google Pay en Chrome).
                  layout: { type: 'tabs' },
                  // Datos del PaymentMethod prellenados desde el form. Stripe los registra
                  // pero los CAMPOS estan ocultos (ver fields abajo) — cliente no los re-tipea.
                  // Country: override del MX default (que viene por cuenta merchant en MX).
                  defaultValues: {
                    billingDetails: {
                      name: formData.tutor_nombre,
                      email: formData.tutor_email,
                      phone: formData.tutor_telefono,
                      address: { country: billingCountry }
                    }
                  },
                  fields: {
                    // Ocultamos 3 campos: name + email + telefono ya estan en defaultValues.
                    // Stripe los recibe y registra en el PaymentMethod, pero NO los muestra
                    // al cliente. Compacta modal ~70px verticales (evita scroll en mobile).
                    billingDetails: { name: 'never', email: 'never', phone: 'never' }
                  }
                });
      
                // CRITICO: attach listeners ANTES de mount (Stripe puede disparar 'ready' rapido)
                var readyFired = false;
                paymentElement.on('ready', function () {
                  readyFired = true;
                  hpDebug('paymentElement ready');
                  if (modalLoadingEl) modalLoadingEl.style.display = 'none';
                  setPayBtnState('idle');
                });
                paymentElement.on('change', function (e) {
                  var methodType = (e && e.value && e.value.type) || 'card';
                  // El evento change del Payment Element expone 'error' (validacion de input
                  // que el Element pinta inline) y 'complete'. Lo guardamos para no duplicar
                  // ese mensaje en nuestra caja al confirmar.
                  elementInlineError = (e && e.error) ? (e.error.message || e.error.code || 'input_error') : null;
                  hpDebug('change: type=' + methodType + ' complete=' + (e && e.complete) + ' inlineError=' + (elementInlineError || 'none'));
      
                  /* ADD PAYMENT INFO · AQUI, no junto a la compra (regla 9 del expediente).
                     `complete: true` significa que los datos de la tarjeta estan puestos y son validos —
                     que es exactamente «anadio su forma de pago». Mandarlo junto a `Purchase`, como se
                     hacia, hace que sus contadores sean identicos para siempre: el embudo diria que nadie
                     abandona nunca con la tarjeta ya puesta, que es la cifra que se mira para saber si el
                     problema esta en el checkout.
                     El id es el MISMO que usa el Worker en CAPI (`api_<pi>`), y `HP_PIXEL` no lo repite
                     dentro de la misma carga: el Element emite `change` en cada tecla. */
                  if (e && e.complete && window.HP_PIXEL) {
                    window.HP_PIXEL.tarjetaPuesta(hpPiId, hpValor, hpMoneda.toUpperCase());
                  }
                });
                paymentElement.on('loaderror', function (ev) {
                  hpDebug('loaderror: ' + (ev && ev.error && ev.error.message ? ev.error.message : 'unknown'));
                  if (modalLoadingEl) modalLoadingEl.style.display = 'none';
                  showModalError('No se pudieron cargar las opciones de pago. ' + (ev && ev.error && ev.error.message ? ev.error.message : ''));
                });
                paymentElement.on('loaderstart', function () {
                  hpDebug('paymentElement loaderstart');
                });
      
                paymentElement.mount(modalElementMount);
                hpDebug('paymentElement mount() called');
      
                // Nota: Express Checkout Element separado se quito (2026-05-29). Decision:
                // el Payment Element con layout 'tabs' muestra Apple Pay / Google Pay como
                // tabs horizontales integradas (mas compacto y elegante que tener ECE arriba
                // con un divisor "o paga con tarjeta"). Funcionalmente equivalente para
                // wallets desktop+mobile, mejor jerarquia visual.
      
                // Fallback: si 'ready' no dispara en 10 seg, asumimos OK y mostramos boton igual.
                // Mejor mostrar el form de pago aunque Stripe no haya confirmado 'ready' que dejar
                // al cliente viendo spinner para siempre.
                setTimeout(function () {
                  if (!readyFired && modalLoadingEl && modalLoadingEl.style.display !== 'none') {
                    hpDebug('ready timeout 10s — habilitando boton igual');
                    modalLoadingEl.style.display = 'none';
                    setPayBtnState('idle');
                  }
                }, 10000);
      
              } catch (e) {
                if (modalLoadingEl) modalLoadingEl.style.display = 'none';
                showModalError(e && e.message ? e.message : 'Hubo un problema. Cierra el modal y vuelve a intentar.');
                setPayBtnState('disabled');
              }
            }
      
            async function handlePayClick() {
              hpDebug('handlePayClick INICIO');
              if (!stripe || !elements || paymentInProgress) { hpDebug('  abort: stripe/elements/inProgress'); return; }
              clearModalError();
              paymentInProgress = true;
              setPayBtnState('processing');
      
              // ====================================================================
              // PATRON CANONICO clientSecret mode (fix de raiz 2026-06-01).
              //
              // CRITICO: NO se llama elements.submit() aqui. elements.submit() es EXCLUSIVO
              // de deferred mode (Elements creado SIN clientSecret). Nosotros inicializamos
              // con clientSecret (ver openStripeModal), asi que confirmPayment hace todo en
              // UN paso. El bug historico de Apple Pay venia de tener un `await elements.submit()`
              // antes de confirmPayment: ese await cedia el event loop y rompia el "user
              // activation" sincrono que Safari exige para abrir el sheet de Apple Pay
              // (GitHub stripe-js#289). Sin ese await, confirmPayment corre directo desde el
              // gesto del click y el sheet abre + el promise resuelve inline.
              //
              // redirect:'if_required' -> resuelve INLINE para tarjeta Y wallets (Apple/Google
              // Pay son non-redirect). Solo redirige cuando el banco fuerza 3DS full-redirect,
              // en cuyo caso checkRedirectReturn lo recoge tras la recarga.
              //
              // billing_details SI van en confirmParams: como ocultamos name/email/phone con
              // fields:{billingDetails:'never'} en openStripeModal, Stripe EXIGE pasarlos aqui
              // en payment_method_data.billing_details (defaultValues NO basta cuando es 'never').
              // Sin esto: "You specified 'never' for fields.billing_details.name ... but did not
              // pass confirmParams.payment_method_data.billing_details.name". El country NO es
              // 'never' (se recoge en el Element), por eso no se incluye aqui.
              // Doc: https://docs.stripe.com/js/payment_intents/confirm_payment#confirm_payment_intent-options-confirmParams
              // ====================================================================
              try {
                var returnUrl = window.location.origin + window.location.pathname;
                var snap = currentFormSnapshot || {};
                var result = await stripe.confirmPayment({
                  elements: elements,
                  confirmParams: {
                    return_url: returnUrl,
                    payment_method_data: {
                      billing_details: {
                        name: snap.tutor_nombre || '',
                        email: snap.tutor_email || '',
                        phone: snap.tutor_telefono || ''
                      }
                    }
                  },
                  redirect: 'if_required'
                });
      
                hpDebug('confirmPayment resolvio. type=' + (result.error ? result.error.type : 'none') + ' code=' + (result.error ? (result.error.code || '') : '') + ' decline=' + (result.error ? (result.error.decline_code || '') : '') + ' pi.status=' + (result.paymentIntent ? result.paymentIntent.status : 'null'));
      
                if (result.error) {
                  // === Display de errores: UNA sola fuente, sin duplicado, sin vacio ===
                  // Discriminador correcto (no el tipo del error: Amex y Visa devuelven ambos
                  // card_declined al confirmar). El discriminador es si el ELEMENT ya esta
                  // mostrando el error inline, que lo sabemos por elementInlineError (evento 'change'):
                  //   - Errores de INPUT (marca no soportada como Amex, numero incompleto): el Element
                  //     los pinta inline durante el tipeo -> elementInlineError seteado -> NO duplicamos.
                  //   - Declines de CONFIRMACION (currency_not_supported, card_declined real): el Element
                  //     NO los pinta en nuestro modal (verificado en vivo con Visa MX) y elementInlineError
                  //     es null -> los mostramos NOSOTROS.
                  // (La instrumentacion del log 'change: ... inlineError=' verifica este mecanismo en vivo.)
                  // Discriminador EMPIRICO (capturado server-side de la cuenta real, no supuesto):
                  //   - Marca NO aceptada (Amex/Diners/etc.): card_error + decline_code='card_not_supported'.
                  //     El Element la detecta por BIN al tipear y la pinta INLINE -> NO duplicar.
                  //   - validation_error (numero incompleto/invalido): el Element tambien lo pinta inline -> NO duplicar.
                  //   - Resto de declines de confirmacion (currency_not_supported, insufficient_funds,
                  //     card_declined real, etc.): el Element NO los pinta en nuestro modal (verificado en
                  //     vivo con Visa MX) -> los mostramos NOSOTROS, con el mensaje localizado de Stripe.
                  // (El instrumento 'change: ... inlineError' confirmo que el Element NO expone el error de
                  //  marca al JS -> por eso el discriminador es decline_code, no el evento change.)
                  var errType = result.error.type;
                  var declineCode = result.error.decline_code || '';
                  /* QUIEN PINTA CADA ERROR — LA LISTA ES DE STRIPE, NO NUESTRA (20-ago-2026).
                     Hasta hoy esto se decidia por una regla deducida en vivo («los declines de
                     confirmacion no los pinta el Element»), y era FALSA: con la tarjeta sin fondos, el
                     mensaje salia DOS VECES —en rojo bajo el campo, escrito por Stripe, y otra vez en
                     nuestra caja rosa—. Se vio en la captura del instrumento; medir por la API no lo
                     habria enseniado nunca.
                     La doc oficial del Payment Element (seccion «Errores») enumera los codigos que el
                     Element muestra EL MISMO durante la confirmacion. Es el contrato del proveedor, no
                     una lista nuestra: se copia tal cual y se cita de donde sale.
                     `currency_not_supported` NO esta en ella — por eso la regla 6 puede dar su mensaje
                     sin arriesgar un duplicado, y por eso va PRIMERO.
                     Si Stripe anadiera un codigo a su lista, volveria a haber duplicado: lo caza el
                     examen del modal, que compara lo que dice nuestra caja con lo que dice el iframe. */
                  var LOS_PINTA_STRIPE = ['card_declined', 'card_velocity_exceeded', 'expired_card',
                    'fraudulent', 'generic_decline', 'incorrect_cvc', 'incorrect_number', 'incorrect_zip',
                    'insufficient_funds', 'invalid_cvc', 'invalid_expiry_month', 'invalid_expiry_year',
                    'live_mode_test_card', 'lost_card', 'processing_error', 'stolen_card',
                    'test_mode_live_card'];
                  var codigoDelFallo = declineCode || result.error.code || '';
                  var loPintaStripe = LOS_PINTA_STRIPE.indexOf(codigoDelFallo) >= 0;
                  var esDeMoneda = declineCode === 'currency_not_supported' || result.error.code === 'currency_not_supported';
                  if (esDeMoneda) {
                    // REGLA 6. Se le dice lo que pasa de verdad, y se le ofrece la salida.
                    var actual = nombreDeMoneda(window.HP_SELECTED_CURRENCY || 'eur');
                    var suya = monedaDeSuPais();
                    /* La frase se construye para que el nombre de la moneda vaya SIEMPRE en singular y
                       entre parentesis. Suena mejor «pagos en euros» que «en euro», pero pluralizar bien
                       en espaniol no es aniadir una ese: seria «peso mexicanos», «libra esterlinas».
                       Antes que escribir un pluralizador para quince monedas, se redacta de forma que el
                       singular sea correcto en las quince. */
                    var aviso = 'Tu banco no admite cobros en esta moneda (' + actual + '). ' +
                                'No es un rechazo de tu tarjeta: la tarjeta está bien.';
                    if (suya) {
                      showModalErrorConOferta(aviso + ' Puedes pagar en la moneda de tu país: ' + nombreDeMoneda(suya) + '.',
                        'Cambiar a ' + nombreDeMoneda(suya),
                        function () {
                          /* Cambiar de moneda obliga a un cobro NUEVO: el que hay creado esta en la
                             moneda vieja. Se cierra y se vuelve a pulsar el boton, que es el camino
                             normal — asi no hay una segunda forma de crear un cobro que mantener. */
                          paymentInProgress = false;
                          if (window.HP_setCurrency) window.HP_setCurrency(suya);
                          clearModalError();
                          closeModalIfAllowed();
                          var cta = DOC.getElementById('btnSolicitarDieta') ||
                                    (window.__raiz && window.__raiz.getElementById && window.__raiz.getElementById('btnSolicitarDieta'));
                          if (cta) setTimeout(function () { cta.click(); }, 60);
                        });
                    } else {
                      showModalError(aviso + ' Prueba con otra tarjeta, o escríbeme y lo resolvemos.');
                    }
                  } else if (errType === 'validation_error' || declineCode === 'card_not_supported' || loPintaStripe) {
                    /* Lo pinta el Element dentro de su iframe. Nuestra caja se queda CALLADA y ademas se
                       limpia: si venia de un intento anterior con otro texto, dejarla puesta seria peor
                       que duplicar — serian dos mensajes DISTINTOS sobre el mismo pago. */
                    clearModalError();
                  } else if (errType === 'card_error') {
                    // Un error de tarjeta que Stripe NO pinta: aqui el silencio seria dejarla sin saber.
                    showModalError(result.error.message || 'Tu tarjeta fue rechazada. Intenta con otra tarjeta.');
                  } else {
                    // network / api_error / desconocido: mensaje generico en español.
                    showModalError('Hubo un problema procesando el pago. Intenta de nuevo en unos segundos.');
                  }
                  paymentInProgress = false;
                  setPayBtnState('idle');
                  return;
                }
      
                // Exito inline (tarjeta + Apple Pay + Google Pay todos resuelven aqui con if_required).
                var pi = result.paymentIntent;
                if (pi && (pi.status === 'succeeded' || pi.status === 'processing')) {
                  hpDebug('  -> showSuccessState (inline)');
                  /* PURCHASE. El id es el MISMO que el Worker usa en CAPI desde el webhook (`pur_<pi>`),
                     que es lo que hace que la compra se cuente UNA vez aunque lleguen las dos. El webhook
                     sigue siendo la fuente garantizada: si la clienta cierra la pestana, este no sale y
                     el del servidor si. */
                  if (window.HP_PIXEL) window.HP_PIXEL.compra(pi.id, hpValorMayor(pi.amount, pi.currency), String(pi.currency || 'eur').toUpperCase(), pi.status);
                  showSuccessState();
                } else if (pi) {
                  showModalError('Estado del pago: ' + pi.status + '. Si el cargo aparece en tu tarjeta, contactanos.');
                  paymentInProgress = false;
                  setPayBtnState('idle');
                }
                // Si no hay pi ni error: 3DS redirect bancario en curso; la pagina recarga
                // y checkRedirectReturn lo recoge. (Raro; tarjeta/wallets resuelven inline.)
              } catch (e) {
                hpDebug('handlePayClick EXCEPTION: ' + (e && e.message ? e.message : e));
                showModalError(e && e.message ? e.message : 'Hubo un error inesperado. Intenta de nuevo.');
                paymentInProgress = false;
                setPayBtnState('idle');
              }
            }
      
            function showSuccessState() {
              paymentInProgress = false;
              /* LA MEMORIA SE OLVIDA AL PAGAR (29-ago-2026, hallazgo grave de la auditoria de la etapa 4).
                 Sin esto, el siguiente visitante del mismo navegador —un ordenador compartido, uno publico—
                 encontraba el cuestionario de la anterior con su nombre, su correo y su telefono, y para
                 siempre. Los dos caminos del exito (pago en linea y vuelta del 3DS) pasan por aqui. */
              if (window.HP_olvidaCuestionario) window.HP_olvidaCuestionario();
              if (viewPayment) viewPayment.setAttribute('hidden', '');
              if (viewSuccess) viewSuccess.removeAttribute('hidden');
      
              if (currentFormSnapshot) {
                var fullName = currentFormSnapshot.tutor_nombre || '';
                var firstName = fullName.trim().split(/\s+/)[0] || fullName;
                if (successName) successName.textContent = firstName;
                if (successPerro) successPerro.textContent = currentFormSnapshot.perro_nombre || 'tu perro';
                if (successEmail) successEmail.textContent = currentFormSnapshot.tutor_email || '';
              }
      
              // Feedback dentro de la pagina: deshabilita el boton y muestra "Pedido recibido".
              // NO es lock permanente — un reload da formulario fresco para otra compra
              // (cliente con 2 perros, o testing). El anti-doble-cargo del MISMO pago lo
              // cubren paymentInProgress + idempotency key, no este estado de UI.
              btn.disabled = true;
              btn.textContent = '✓ Pedido recibido';
              var stickyBtn = root.querySelector('.sticky-bar a.btn');
              if (stickyBtn) {
                stickyBtn.textContent = '✓ Pedido recibido';
                stickyBtn.removeAttribute('href');
                stickyBtn.style.pointerEvents = 'none';
                stickyBtn.style.opacity = '0.65';
              }
            }
      
            function closeModalIfAllowed() {
              // No permitir cerrar durante procesamiento activo de Stripe
              if (paymentInProgress) return;
              hideModal();
            }
      
            if (modalCloseBtn) modalCloseBtn.addEventListener('click', closeModalIfAllowed);
            if (successCloseBtn) successCloseBtn.addEventListener('click', hideModal);
            if (modal) modal.addEventListener('click', function (e) {
              if (e.target === modal) closeModalIfAllowed();
            });
            document.addEventListener('keydown', function (e) {
              if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) closeModalIfAllowed();
            });
            if (modalPayBtn) modalPayBtn.addEventListener('click', handlePayClick);
      
            // ============================================================
            // Submit handler principal
            // ============================================================
            async function handleSubmit() {
              // Nota (2026-06-01): se removio el lock de sessionStorage 'hpDietaPaid'.
              // Razon: requeria re-llenar 13 campos para pagar de nuevo, asi que el
              // doble-cargo accidental era casi imposible; el lock solo causaba friccion
              // (cliente con 2 perros no podia comprar la 2da dieta sin cerrar el browser).
              // Anti-doble-cargo real se mantiene con: (1) paymentInProgress (boton disabled
              // durante el submit en curso) y (2) idempotency key UUID por intento (Stripe
              // dedup 24h). Ver handlePayClick + openStripeModal.
      
              clearFormError();
              var result = gatherFormData();
              if (result.missing.length) {
                var labels = result.missing.map(function (m) { return FIELD_LABELS[m.name] || m.name; });
                var msg = labels.length === 1
                  ? 'Falta completar: ' + labels[0] + '.'
                  : 'Faltan estos datos: ' + labels.slice(0, -1).join(', ') + ' y ' + labels[labels.length - 1] + '.';
                showFormError(msg, result.missing[0].el);
                return;
              }
      
              // Validacion permissive del telefono: solo verifica que haya >=1 digito.
              // No bloqueamos por libphonenumber/formato — preferimos perder una resena
              // que perder un cliente por filtro estricto (decision negocio 2026-05-29).
      
              // Anti-doble-click: disabled instantaneo
              btn.disabled = true;
              btn.textContent = 'Preparando pago...';
      
              await openStripeModal(result.data);
      
              // Re-habilitar el boton tras abrir el modal. openStripeModal resuelve cuando
              // el modal esta montado (el cliente AUN no pago), asi que re-habilitamos para
              // que pueda reintentar si cierra el modal sin pagar. Si SI paga, showSuccessState
              // deshabilita el boton con "Pedido recibido" (estado de UI, un reload da form fresco).
              btn.disabled = false;
              btn.innerHTML = originalLabel;
              if (window.HP_applyPrices) window.HP_applyPrices(); // re-aplica la moneda actual (no revertir al precio de respaldo)
            }
      
            btn.addEventListener('click', handleSubmit);
      
            // Enter en cualquier input (excepto textarea) dispara submit.
            // Guard (fix I4-audit): si el boton ya esta disabled (pago en curso o "Pedido
            // recibido"), Enter NO debe re-disparar handleSubmit -> evitaba un hueco de
            // segundo cargo (el form sigue lleno tras pagar; Enter abria otro PaymentIntent).
            var formContainer = root.querySelector('.form-inner');
            if (formContainer) {
              formContainer.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' && e.target && e.target.tagName !== 'TEXTAREA') {
                  e.preventDefault();
                  if (btn.disabled) return;
                  handleSubmit();
                }
              });
            }
      
            // ============================================================
            // PRELOAD de Stripe.js al cargar la pagina (no al hacer clic).
            // Recomendacion oficial de Stripe (Radar/Advanced fraud detection): cargar
            // js.stripe.com en CADA pagina, no solo en el checkout. Doble beneficio:
            //   1) Velocidad: para cuando el cliente da clic en "Solicitar dieta",
            //      Stripe.js ya esta en cache -> el modal abre sin esperar ~400KB en el
            //      camino critico (era el cuello de ~1-2s en movil). loadStripeJs() memoiza
            //      via stripeJsPromise, asi que openStripeModal reusa esta misma promesa.
            //   2) Anti-fraude: Radar observa al visitante desde que llega (mejores señales
            //      de riesgo, menos disputas/chargebacks). Esta landing ES Home + Dieta de
            //      longevidad, asi que cubre todo el funnel.
            // El <script> carga async: NO bloquea el render de la pagina.
            // Ref: https://docs.stripe.com/radar/optimize-fraud-signals
            // ============================================================
            try { loadStripeJs(); } catch (_) {}
      
            // ============================================================
            // Retorno post-pago — FALLBACK solo para 3DS full-redirect (banco fuerza
            // recarga completa, ~raro). El camino normal (tarjeta, Apple Pay, Google Pay)
            // resuelve INLINE en handlePayClick con redirect:'if_required', sin pasar por
            // aqui. Si el banco SI redirige, volvemos a esta URL con
            // ?payment_intent_client_secret=xxx, verificamos via retrievePaymentIntent y
            // mostramos exito. El cobro NUNCA se pierde: el webhook server-side crea la
            // order independiente de esta UI.
            // ============================================================
            (async function checkRedirectReturn() {
              try {
                var url = new URL(window.location.href);
                var clientSecret = url.searchParams.get('payment_intent_client_secret');
                hpDebug('checkRedirectReturn: clientSecret en URL = ' + (clientSecret ? 'SI' : 'no'));
                if (!clientSecret) return;
                hpDebug('  -> retorno post-pago detectado, verificando...');
      
                // Limpiar URL para que F5 no re-procese
                url.searchParams.delete('payment_intent_client_secret');
                url.searchParams.delete('payment_intent');
                url.searchParams.delete('redirect_status');
                try { window.history.replaceState({}, document.title, url.toString()); } catch (_) {}
      
                // Feedback INMEDIATO: abrir modal con spinner mientras verificamos (1-2s).
                // Asi el cliente no ve la landing "vacia" y cree que el pago se perdio.
                if (modalLoadingEl) modalLoadingEl.style.display = 'block';
                if (modalElementMount) modalElementMount.style.display = 'none';
                if (viewPayment) viewPayment.removeAttribute('hidden');
                if (viewSuccess) viewSuccess.setAttribute('hidden', '');
                showModal();
      
                // CRITICO (fix 2026-06-01): NO confiar en el query param `redirect_status`.
                // Apple Pay / Google Pay hacen redirect completo (aunque pongamos
                // redirect:'if_required') y NO siempre incluyen `redirect_status` en el
                // return_url — es un param NO documentado por Stripe. Stripe solo garantiza
                // `payment_intent` + `payment_intent_client_secret`. La UNICA fuente de verdad
                // es retrievePaymentIntent(clientSecret) y leer pi.status.
                // Bug anterior: si Apple Pay volvia sin redirect_status, el guard cortaba el
                // flujo y el cliente NO veia la pantalla de exito aunque SI habia pagado.
                // Doc: https://docs.stripe.com/payments/payment-intents/verifying-status
                // pk: sessionStorage primero, fallback a la constante STRIPE_PK (fix I2-audit).
                // El pk SIEMPRE esta disponible -> SIEMPRE verificamos via retrievePaymentIntent.
                // Se elimino el branch "sin pk -> asumir exito" que daba falso positivo si el
                // cliente cancelaba el wallet (Safari ITP borra sessionStorage en el redirect).
                var pk = STRIPE_PK;
                try { pk = sessionStorage.getItem('hpStripePk') || STRIPE_PK; } catch (_) { pk = STRIPE_PK; }
      
                var StripeCtor = await loadStripeJs();
                var stripeVerify = StripeCtor(pk);
                var verifyRes = await stripeVerify.retrievePaymentIntent(clientSecret);
                var pi = verifyRes.paymentIntent;
                if (pi && (pi.status === 'succeeded' || pi.status === 'processing')) {
                  currentFormSnapshot = {
                    tutor_nombre: (pi.metadata && pi.metadata.tutor_nombre) || '',
                    perro_nombre: (pi.metadata && pi.metadata.perro_nombre) || '',
                    tutor_email: (pi.metadata && pi.metadata.tutor_email) || ''
                  };
                  // Mismo Purchase que arriba, para quien vuelve de 3DS. El id repetido no cuenta dos veces.
                  if (window.HP_PIXEL) window.HP_PIXEL.compra(pi.id, hpValorMayor(pi.amount, pi.currency), String(pi.currency || 'eur').toUpperCase(), pi.status);
                  showSuccessState();
                  showModal();
                } else if (pi && (pi.status === 'requires_payment_method' || pi.status === 'canceled')) {
                  // Pago realmente fallido/cancelado.
                  hideModal();
                  showFormError('El pago no se completó. Si crees que es un error, vuelve a intentar.');
                } else {
                  hideModal();
                  showFormError('El pago no se completó (estado: ' + (pi ? pi.status : 'desconocido') + ').');
                }
              } catch (e) {
                // Fix I3-audit: NO dejar el spinner colgado si retrievePaymentIntent falla
                // (red caida, Stripe.js no carga). El cobro lo procesa el webhook server-side;
                // mostramos mensaje neutro en vez de spinner eterno.
                hpDebug('checkRedirectReturn EXCEPTION: ' + (e && e.message ? e.message : e));
                hideModal();
                showFormError('Tu pago se está procesando. Si se realizó el cargo, recibirás un correo de confirmación en breve.');
              }
            })();
          }
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancarPago);
          else arrancarPago();
          })();
      
      /* #1 data-visible-if="campo=valor": el elemento solo se muestra si el input
             (radio/checkbox/select) llamado "campo" tiene ese "valor" seleccionado.
             Funciona standalone (document) y dentro del Shadow DOM (el build reescribe
             document.* -> root.*). Self-contained, sin handlers inline globales. */
          (function () {
            var conds = root.querySelectorAll('[data-visible-if]');
            if (!conds.length) return;
            function evaluar() {
              conds.forEach(function (el) {
                var spec = el.getAttribute('data-visible-if') || '';
                var eq = spec.indexOf('=');
                if (eq < 0) return;
                var name = spec.slice(0, eq).trim();
                var val = spec.slice(eq + 1).trim();
                var sel = root.querySelector('input[name="' + name + '"]:checked');
                el.style.display = (sel && sel.value === val) ? 'block' : 'none';
              });
            }
            root.querySelectorAll('input, select, textarea').forEach(function (inp) {
              inp.addEventListener('change', evaluar);
            });
            evaluar();
          })();
      
      /* Country picker — selector de país para el teléfono.
             - Auto-detecta el país inicial: navigator.language (es-ES, es-MX...) -> timezone -> ES default
             - Modal en mobile (full-screen abajo), centrado en desktop
             - Búsqueda en vivo, ignora acentos
             - Compone tutor_telefono en formato E.164 (+34666123456) en el campo oculto */
          (function () {
            // ISO|nombre|dial — ~240 países sorted por nombre español en runtime
            var COUNTRIES_RAW = "AF|Afganistán|93\nAL|Albania|355\nDE|Alemania|49\nAD|Andorra|376\nAO|Angola|244\nAI|Anguila|1\nAG|Antigua y Barbuda|1\nSA|Arabia Saudita|966\nDZ|Argelia|213\nAR|Argentina|54\nAM|Armenia|374\nAW|Aruba|297\nAU|Australia|61\nAT|Austria|43\nAZ|Azerbaiyán|994\nBS|Bahamas|1\nBH|Baréin|973\nBD|Bangladés|880\nBB|Barbados|1\nBE|Bélgica|32\nBZ|Belice|501\nBJ|Benín|229\nBM|Bermudas|1\nBY|Bielorrusia|375\nBO|Bolivia|591\nBA|Bosnia y Herzegovina|387\nBW|Botsuana|267\nBR|Brasil|55\nBN|Brunéi|673\nBG|Bulgaria|359\nBF|Burkina Faso|226\nBI|Burundi|257\nBT|Bután|975\nCV|Cabo Verde|238\nKH|Camboya|855\nCM|Camerún|237\nCA|Canadá|1\nQA|Catar|974\nTD|Chad|235\nCL|Chile|56\nCN|China|86\nCY|Chipre|357\nVA|Ciudad del Vaticano|39\nCO|Colombia|57\nKM|Comoras|269\nCG|Congo|242\nCD|Congo (RDC)|243\nKP|Corea del Norte|850\nKR|Corea del Sur|82\nCI|Costa de Marfil|225\nCR|Costa Rica|506\nHR|Croacia|385\nCU|Cuba|53\nCW|Curazao|599\nDK|Dinamarca|45\nDM|Dominica|1\nEC|Ecuador|593\nEG|Egipto|20\nSV|El Salvador|503\nAE|Emiratos Árabes Unidos|971\nER|Eritrea|291\nSK|Eslovaquia|421\nSI|Eslovenia|386\nES|España|34\nUS|Estados Unidos|1\nEE|Estonia|372\nET|Etiopía|251\nPH|Filipinas|63\nFI|Finlandia|358\nFJ|Fiyi|679\nFR|Francia|33\nGA|Gabón|241\nGM|Gambia|220\nGE|Georgia|995\nGH|Ghana|233\nGI|Gibraltar|350\nGD|Granada|1\nGR|Grecia|30\nGL|Groenlandia|299\nGP|Guadalupe|590\nGU|Guam|1\nGT|Guatemala|502\nGF|Guayana Francesa|594\nGN|Guinea|224\nGQ|Guinea Ecuatorial|240\nGW|Guinea-Bisáu|245\nGY|Guyana|592\nHT|Haití|509\nHN|Honduras|504\nHK|Hong Kong|852\nHU|Hungría|36\nIN|India|91\nID|Indonesia|62\nIQ|Irak|964\nIR|Irán|98\nIE|Irlanda|353\nIS|Islandia|354\nKY|Islas Caimán|1\nCK|Islas Cook|682\nFO|Islas Feroe|298\nFK|Islas Malvinas|500\nMH|Islas Marshall|692\nSB|Islas Salomón|677\nTC|Islas Turcas y Caicos|1\nVG|Islas Vírgenes Británicas|1\nVI|Islas Vírgenes de los EE.UU.|1\nIL|Israel|972\nIT|Italia|39\nJM|Jamaica|1\nJP|Japón|81\nJO|Jordania|962\nKZ|Kazajistán|7\nKE|Kenia|254\nKG|Kirguistán|996\nKI|Kiribati|686\nKW|Kuwait|965\nLA|Laos|856\nLS|Lesoto|266\nLV|Letonia|371\nLB|Líbano|961\nLR|Liberia|231\nLY|Libia|218\nLI|Liechtenstein|423\nLT|Lituania|370\nLU|Luxemburgo|352\nMO|Macao|853\nMK|Macedonia del Norte|389\nMG|Madagascar|261\nMY|Malasia|60\nMW|Malaui|265\nMV|Maldivas|960\nML|Malí|223\nMT|Malta|356\nMA|Marruecos|212\nMQ|Martinica|596\nMU|Mauricio|230\nMR|Mauritania|222\nMX|México|52\nFM|Micronesia|691\nMD|Moldavia|373\nMC|Mónaco|377\nMN|Mongolia|976\nME|Montenegro|382\nMS|Montserrat|1\nMZ|Mozambique|258\nMM|Myanmar|95\nNA|Namibia|264\nNR|Nauru|674\nNP|Nepal|977\nNI|Nicaragua|505\nNE|Níger|227\nNG|Nigeria|234\nNO|Noruega|47\nNC|Nueva Caledonia|687\nNZ|Nueva Zelanda|64\nOM|Omán|968\nNL|Países Bajos|31\nPK|Pakistán|92\nPW|Palaos|680\nPS|Palestina|970\nPA|Panamá|507\nPG|Papúa Nueva Guinea|675\nPY|Paraguay|595\nPE|Perú|51\nPF|Polinesia Francesa|689\nPL|Polonia|48\nPT|Portugal|351\nPR|Puerto Rico|1\nGB|Reino Unido|44\nCF|República Centroafricana|236\nCZ|República Checa|420\nDO|República Dominicana|1\nRW|Ruanda|250\nRO|Rumanía|40\nRU|Rusia|7\nWS|Samoa|685\nKN|San Cristóbal y Nieves|1\nSM|San Marino|378\nVC|San Vicente y las Granadinas|1\nLC|Santa Lucía|1\nST|Santo Tomé y Príncipe|239\nSN|Senegal|221\nRS|Serbia|381\nSC|Seychelles|248\nSL|Sierra Leona|232\nSG|Singapur|65\nSY|Siria|963\nSO|Somalia|252\nLK|Sri Lanka|94\nZA|Sudáfrica|27\nSD|Sudán|249\nSS|Sudán del Sur|211\nSE|Suecia|46\nCH|Suiza|41\nSR|Surinam|597\nSZ|Suazilandia|268\nTH|Tailandia|66\nTW|Taiwán|886\nTZ|Tanzania|255\nTJ|Tayikistán|992\nTL|Timor Oriental|670\nTG|Togo|228\nTO|Tonga|676\nTT|Trinidad y Tobago|1\nTN|Túnez|216\nTM|Turkmenistán|993\nTR|Turquía|90\nTV|Tuvalu|688\nUA|Ucrania|380\nUG|Uganda|256\nUY|Uruguay|598\nUZ|Uzbekistán|998\nVU|Vanuatu|678\nVE|Venezuela|58\nVN|Vietnam|84\nYE|Yemen|967\nDJ|Yibuti|253\nZM|Zambia|260\nZW|Zimbabue|263";
      
            var COUNTRIES = COUNTRIES_RAW.split('\n').map(function (line) {
              var p = line.split('|');
              return { iso: p[0], name: p[1], dial: p[2] };
            });
            // Orden alfabético en español (maneja acentos correctamente)
            COUNTRIES.sort(function (a, b) { return a.name.localeCompare(b.name, 'es'); });
      
            // Países top arriba: México primero (mercado principal desde el 7-sep-2026) + LATAM + España + diáspora US
            var POPULAR_ISO = ['MX', 'ES', 'AR', 'CO', 'CL', 'PE', 'VE', 'UY', 'US'];
            var POPULAR = POPULAR_ISO.map(function (iso) {
              return COUNTRIES.find(function (c) { return c.iso === iso; });
            }).filter(Boolean);
      
            // Longitud esperada del numero local (sin codigo de pais) por ISO.
            // Numero = [min, max] digitos. Si no esta en el mapa: fallback [7, 15] (E.164 general).
            // Fuente: numbering plans nacionales + Wikipedia/Stripe.
            var PHONE_LEN = {
              ES: [9, 9],   MX: [10, 10], AR: [10, 11], CO: [10, 10], CL: [9, 9],
              PE: [9, 9],   VE: [10, 10], UY: [8, 9],   US: [10, 10], CA: [10, 10],
              GB: [10, 10], PT: [9, 9],   FR: [9, 9],   DE: [10, 11], IT: [9, 10],
              BR: [10, 11], BO: [8, 8],   PA: [8, 8],   PY: [9, 9],   EC: [9, 9],
              CR: [8, 8],   GT: [8, 8],   HN: [8, 8],   NI: [8, 8],   SV: [8, 8],
              DO: [10, 10], CU: [8, 8],   PR: [10, 10], NL: [9, 9],   BE: [9, 9],
              CH: [9, 9],   AT: [10, 13], DK: [8, 8],   SE: [9, 9],   NO: [8, 8],
              FI: [9, 10],  IE: [9, 9],   PL: [9, 9],   GR: [10, 10], CZ: [9, 9],
              AU: [9, 9],   NZ: [8, 10],  JP: [10, 10], CN: [11, 11], IN: [10, 10]
            };
            function expectedLen(iso) { return PHONE_LEN[iso] || [7, 15]; }
            function digitsOf(str) { return (str || '').replace(/\D/g, ''); }
      
            // libphonenumber-js REMOVIDO (2026-05-29): validacion permissive ya no lo necesita.
            // Ahorro: ~80KB JS lazy. Funcion loadLibPhone() y libPromise eliminados.
      
            // ISO 2 letras -> URL de bandera SVG en flagcdn.com (universal, funciona en Windows)
            function flagUrl(iso) {
              return 'https://flagcdn.com/' + iso.toLowerCase() + '.svg';
            }
      
            // País inicial. Estuvo fijo en España hasta el 2026-08-12, cuando Jeanette confirmó
            // que vende a España y a México por igual: a media clientela le salía la bandera
            // equivocada, y con ella la longitud de número equivocada (9 dígitos en vez de 10),
            // así que su teléfono correcto se marcaba como error.
            //
            // Se mira primero la REGIÓN del idioma del navegador (es-MX, es-AR…) y, si el
            // idioma no trae región (es a secas, que es lo normal en España), la zona horaria.
            // Si nada de eso resuelve, España. El cliente siempre puede cambiarlo a mano.
            var ZONA_A_PAIS = {
              'America/Mexico_City': 'MX', 'America/Monterrey': 'MX', 'America/Tijuana': 'MX',
              'America/Cancun': 'MX', 'America/Merida': 'MX', 'America/Chihuahua': 'MX',
              'America/Hermosillo': 'MX', 'America/Mazatlan': 'MX',
              'America/Argentina/Buenos_Aires': 'AR', 'America/Bogota': 'CO',
              'America/Santiago': 'CL', 'America/Lima': 'PE', 'America/Caracas': 'VE',
              'America/Montevideo': 'UY', 'Atlantic/Canary': 'ES', 'Europe/Madrid': 'ES',
            };
            /* EL IDIOMA DEL NAVEGADOR NO DICE DONDE ESTA NADIE (20-ago-2026).
               Esta funcion da la lada PROVISIONAL, la que se ve durante el instante que tarda en
               contestar la geolocalizacion. Empezaba mirando `navigator.language`: un navegador
               configurado en ingles devuelve `en-US` y la lada salia +1 — daba igual que la persona
               estuviera en Madrid. Y si la geolocalizacion fallaba, ahi se quedaba: modal en INGLES,
               pidiendo un ZIP code, en una tienda cuyo mercado es Espana. Medido hoy en vivo.
               Ese dato dice en que idioma alguien prefiere leer, no donde vive. Se retira.
               Queda la ZONA HORARIA, que si habla de donde estas, y por debajo ESPANA, que es lo que
               Enrique decidio como respaldo: es donde se va a pautar primero. */
            function detectInitialCountry() {
              var busca = function (iso) { return COUNTRIES.find(function (c) { return c.iso === iso; }); };
              try {
                var zona = Intl.DateTimeFormat().resolvedOptions().timeZone;
                if (ZONA_A_PAIS[zona] && busca(ZONA_A_PAIS[zona])) return busca(ZONA_A_PAIS[zona]);
              } catch (e) { /* navegador sin Intl completo: se cae a México */ }
              return busca('MX');
            }
      
            // Normaliza para búsqueda (sin acentos, lowercase)
            function normalize(s) {
              return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
            }
      
            // Refs DOM (el build reescribe getElementById a root.* automaticamente en shadow DOM)
            var btn = root.getElementById('phoneCountryBtn');
            var flagEl = root.getElementById('phoneCountryFlag');
            var codeEl = root.getElementById('phoneCountryCode');
            var localInput = root.getElementById('phoneLocalInput');
            var e164Input = root.getElementById('phoneE164');
            var overlay = root.getElementById('countryPickerOverlay');
            var closeBtn = root.getElementById('countryPickerClose');
            var searchInput = root.getElementById('countrySearchInput');
            var listEl = root.getElementById('countryPickerList');
            var phoneStatusEl = root.getElementById('phoneStatus');
            var phoneGroupEl = localInput && localInput.closest ? localInput.closest('.phone-input-group') : null;
      
            if (!btn || !localInput || !e164Input || !overlay) return;
      
            var currentCountry = detectInitialCountry();
            applyCountry(currentCountry);
      
            // Geo: el script multi-moneda llama esto tras /geo para fijar la lada por país.
            // (El cliente siempre puede cambiarla a mano desde el picker.)
            window.HP_setPhoneCountry = function (iso, opciones) {
              if (!iso) return;
              /* LA GEOLOCALIZACION NO PISA UN NUMERO YA ESCRITO (29-ago-2026, cazado por el examen de los
                 siete estados de retomar). `/geo` contesta tarde y llama aqui; si para entonces ya hay
                 digitos en el campo —porque la clienta tecleo rapido, o porque la memoria o el enlace
                 acababan de rellenarlo—, cambiar la lada deja un numero mexicano bajo +34 sin que nadie lo
                 vea. Medido: la memoria ponia +52 5512345678 y un instante despues salia +34 5512345678.
                 La lada la decide quien escribio el numero; la geolocalizacion solo propone cuando aun no
                 hay nada.
                 PERO el guard vale SOLO para lo automatico (`opciones.propuesta`): la primera version lo
                 aplicaba a toda llamada y rompio la regla de Enrique del 20-ago —elegir una moneda de un
                 solo pais arrastra la lada—, que es una ELECCION de la clienta y tiene que mandar aunque ya
                 haya numero. Lo cazo la auditoria de la etapa 4 (29-ago). */
              if (opciones && opciones.propuesta && digitsOf(localInput.value)) return;
              var c = COUNTRIES.find(function (x) { return x.iso === String(iso).toUpperCase(); });
              if (c) applyCountry(c);
            };
      
            /* EL CAMINO DE VUELTA: de un E.164 a lada + numero (etapa 4 de retomar-cuestionario).
               El campo `tutor_telefono` es oculto y se COMPONE desde la lada y el numero; rellenarlo a
               pelo no pinta nada. Esto lo reparte: la lada mas LARGA que sea prefijo de los digitos gana
               (+1 y +1809 no se confunden), y entre paises que comparten lada —+1 son doce— se prefiere
               el que ya estaba puesto (la geolocalizacion suele acertar) y si no, el primero. Vive aqui y
               no en el bloque de retomar porque COUNTRIES es de este ambito y no se exporta. */
            window.HP_setPhoneE164 = function (e164) {
              var digits = digitsOf(e164);
              if (!digits) return false;
              var mejor = null;
              COUNTRIES.forEach(function (c) {
                if (digits.indexOf(c.dial) !== 0) return;
                if (!mejor || c.dial.length > mejor.dial.length) mejor = c;
                else if (c.dial.length === mejor.dial.length && currentCountry && c.iso === currentCountry.iso) mejor = c;
              });
              if (!mejor) return false;
              applyCountry(mejor);
              localInput.value = digits.slice(mejor.dial.length);
              try { localInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
              return true;
            };
            if (window.HP_GEO_COUNTRY) window.HP_setPhoneCountry(window.HP_GEO_COUNTRY, { propuesta: true });
      
            function applyCountry(c) {
              currentCountry = c;
              flagEl.src = flagUrl(c.iso);
              flagEl.alt = c.iso;
              codeEl.textContent = '+' + c.dial;
              // Placeholder segun el pais (cap de caracteres removido a peticion del negocio)
              localInput.placeholder = c.iso === 'ES' ? '666 123 456'
                : c.iso === 'MX' ? '55 1234 5678'
                : c.iso === 'AR' ? '11 1234 5678'
                : c.iso === 'CO' ? '300 123 4567'
                : 'Número local';
              updateE164();
              validatePhoneLive();
            }
      
            function updateE164() {
              var digits = digitsOf(localInput.value);
              var antes = e164Input.value;
              e164Input.value = digits ? '+' + currentCountry.dial + digits : '';
              /* Y SE AVISA (29-ago-2026, auditoria de la etapa 4): el control con `name` es este oculto, y se
                 escribia en silencio. Quien escuche cambios del formulario por nombre —la memoria de
                 «retomar», y cualquier observador futuro— no se enteraba de que el telefono cambio, asi que
                 si era lo ultimo que se tecleaba, no se recordaba. El aviso sale de aqui, del que escribe,
                 para no acoplar bloques entre si. Solo si cambio, para no dar vueltas. */
              if (e164Input.value !== antes) { try { e164Input.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) {} }
            }
      
            // Input local: aceptar dígitos y espacios visualmente, solo dígitos al guardar
            localInput.addEventListener('input', function (e) {
              var raw = e.target.value;
              var cleaned = raw.replace(/[^\d\s]/g, '');
              if (cleaned !== raw) e.target.value = cleaned;
              // (cap de caracteres removido a peticion del negocio: aceptamos cualquier longitud)
              updateE164();
              validatePhoneLive();
            });
            localInput.addEventListener('blur', validatePhoneLive);
            localInput.addEventListener('focus', function () {
              // Limpiar status mientras editan (re-validamos al blur)
              if (phoneStatusEl) phoneStatusEl.className = 'phone-status';
            });
      
            // Setea el estado visual del input + texto debajo
            function setPhoneState(state, msg) {
              if (phoneStatusEl) {
                phoneStatusEl.textContent = msg || '';
                phoneStatusEl.className = 'phone-status' + (state ? ' is-' + state : '');
              }
              if (phoneGroupEl) {
                phoneGroupEl.classList.remove('has-err', 'has-ok');
                if (state === 'err') phoneGroupEl.classList.add('has-err');
                else if (state === 'ok') phoneGroupEl.classList.add('has-ok');
              }
            }
      
            // Validacion permissive (decision negocio 2026-05-29): preferimos perder una
            // resena por numero raro que perder un cliente por filtro estricto.
            // Antes: libphonenumber + digit-count por pais (rechazaba numeros validos
            // ocasionalmente). Ahora: solo requiere >=1 digito.
            function validatePhoneLive() {
              // Sin contador de dígitos ni palomita (a peticion del negocio: no agregan valor / confunden).
              // Validacion permissive: cualquier numero con >=1 digito vale (no bloquea submit).
              setPhoneState(null, '');
              return digitsOf(localInput.value).length >= 1;
            }
            // Expose para que el form handler tambien valide en submit
            window.__hpValidatePhone = validatePhoneLive;
      
            // ---- Picker abrir/cerrar ----
            function openPicker() {
              overlay.removeAttribute('hidden');
              btn.setAttribute('aria-expanded', 'true');
              document.body.style.overflow = 'hidden'; // bloquea scroll del fondo
              renderList('');
              setTimeout(function () { searchInput.focus(); }, 80);
            }
            function closePicker() {
              overlay.setAttribute('hidden', '');
              btn.setAttribute('aria-expanded', 'false');
              document.body.style.overflow = '';
              searchInput.value = '';
              btn.focus();
            }
      
            btn.addEventListener('click', openPicker);
            closeBtn.addEventListener('click', closePicker);
            overlay.addEventListener('click', function (e) {
              if (e.target === overlay) closePicker(); // tap fuera del card cierra
            });
            document.addEventListener('keydown', function (e) {
              if (e.key === 'Escape' && !overlay.hasAttribute('hidden')) closePicker();
            });
      
            // ---- Render + búsqueda ----
            searchInput.addEventListener('input', function () {
              renderList(searchInput.value);
            });
      
            function renderList(query) {
              var q = normalize(query.trim());
              var html = '';
              if (!q) {
                html += '<div class="country-section-label">Más usados</div>';
                html += POPULAR.map(renderItem).join('');
                html += '<div class="country-section-label">Todos los países (A-Z)</div>';
                var popularSet = {};
                POPULAR.forEach(function (c) { popularSet[c.iso] = true; });
                html += COUNTRIES.filter(function (c) { return !popularSet[c.iso]; }).map(renderItem).join('');
              } else {
                var matches = COUNTRIES.filter(function (c) {
                  return normalize(c.name).indexOf(q) !== -1 || c.dial.indexOf(q.replace(/^\+/, '')) !== -1;
                });
                if (matches.length) {
                  html = matches.map(renderItem).join('');
                } else {
                  html = '<div class="country-no-results">Sin resultados para tu búsqueda</div>';
                }
              }
              listEl.innerHTML = html;
            }
      
            function renderItem(c) {
              var sel = c.iso === currentCountry.iso;
              return (
                '<button type="button" class="country-item" data-iso="' + c.iso + '" role="option"' +
                (sel ? ' aria-selected="true"' : '') + '>' +
                  '<img class="country-item-flag" src="' + flagUrl(c.iso) + '" alt="" width="26" height="19" loading="lazy" decoding="async">' +
                  '<span class="country-item-name">' + c.name + '</span>' +
                  '<span class="country-item-code">+' + c.dial + '</span>' +
                '</button>'
              );
            }
      
            // Event delegation para clicks en items
            listEl.addEventListener('click', function (e) {
              var item = e.target.closest && e.target.closest('.country-item');
              if (!item) return;
              var iso = item.getAttribute('data-iso');
              var c = COUNTRIES.find(function (x) { return x.iso === iso; });
              if (c) { applyCountry(c); closePicker(); }
            });
          })();
      
      (function () {
          var item = {
            ProductName: "Dieta de longevidad",
            ProductID: "9756287074601",
            Categories: ["Dieta"],
            ImageURL: "https://cdn.shopify.com/s/files/1/0937/6645/1497/files/CopiadeFoto1.1Platolongevidad.jpg",
            URL: window.location.href,
            Price: 69
          };
          function fire() {
            if (!window.klaviyo || typeof window.klaviyo.push !== "function") return false;
            window.klaviyo.push(["track", "Viewed Product", item]);
            window.klaviyo.push(["trackViewedItem", {
              Title: item.ProductName, ItemId: item.ProductID, Categories: item.Categories,
              ImageUrl: item.ImageURL, Url: item.URL, Metadata: { Price: item.Price }
            }]);
            return true;
          }
          if (fire()) return;
          var n = 0, iv = setInterval(function () { if (fire() || ++n > 40) clearInterval(iv); }, 500);
        })();
      
      /* Multi-moneda: al cargar consulta /geo (país→moneda) + /prices (precios actuales con
             auto-FX vivo), fija window.HP_SELECTED_CURRENCY y actualiza el precio del hero.
             create-PI lee HP_SELECTED_CURRENCY; el selector del header llama HP_setCurrency().
             Robusto: si /geo o /prices fallan → se queda en MXN/$1,194 (sin romper, sin mismatch). Ese respaldo se sube CON el precio: si se
             queda viejo, la pagina ensena un precio que ya no existe justo el dia que el Worker falla. */
          (function () {
            var API = window.HP_API_BASE;   // resuelto una sola vez arriba
            // Modo prueba: ?pay_test=<token> en la URL → se manda en create-PI (cobra el mínimo si el token coincide en el Worker).
            try { var _pt = new URLSearchParams(location.search).get('pay_test'); if (_pt) window.HP_PAY_TEST = _pt; } catch (_) {}
            var ZERO = { clp:1,pyg:1,jpy:1,krw:1,vnd:1,ugx:1,isk:1,huf:1,twd:1,bif:1,clf:1,djf:1,gnf:1,kmf:1,mga:1,rwf:1,vuv:1,xaf:1,xof:1,xpf:1 };
            window.HP_SELECTED_CURRENCY = window.HP_SELECTED_CURRENCY || 'mxn';
            window.HP_PRICES = window.HP_PRICES || {};
            // Orden del selector (populares primero) + país para la banderita (flagcdn).
            var CUR_ORDER = ['mxn','eur','usd','gbp','cad','cop','clp','pen','uyu','gtq','dop','crc','nio','hnl','pyg'];
            var CUR_FLAG = { eur:'eu',usd:'us',mxn:'mx',gbp:'gb',cad:'ca',cop:'co',clp:'cl',pen:'pe',uyu:'uy',gtq:'gt',dop:'do',crc:'cr',nio:'ni',hnl:'hn',pyg:'py' };
            function flagUrl(cur) { return 'https://flagcdn.com/' + (CUR_FLAG[cur] || 'eu') + '.svg'; }
            function fmt(amount, cur) {
              cur = (cur || 'mxn').toLowerCase();
              var zero = !!ZERO[cur], major = zero ? amount : amount / 100;
              try { return new Intl.NumberFormat(navigator.language || 'es-ES', { style: 'currency', currency: cur.toUpperCase(), currencyDisplay: 'narrowSymbol', minimumFractionDigits: 0, maximumFractionDigits: zero ? 0 : 2 }).format(major); }
              catch (_) { return major.toFixed(zero ? 0 : 2) + ' ' + cur.toUpperCase(); }
            }
            function updatePrices() {
              var a = window.HP_PRICES[window.HP_SELECTED_CURRENCY];
              if (typeof a !== 'number') return;
              var txt = fmt(a, window.HP_SELECTED_CURRENCY);
              var els = root.querySelectorAll('.js-precio');
              for (var i = 0; i < els.length; i++) els[i].textContent = txt;
            }
            window.HP_applyPrices = updatePrices; // expuesto para que el form re-aplique tras restaurar el botón
            function updateBtn() {
              var f = root.getElementById('currencyFlag'), code = root.getElementById('currencyCode');
              if (f) f.src = flagUrl(window.HP_SELECTED_CURRENCY);
              if (code) code.textContent = window.HP_SELECTED_CURRENCY.toUpperCase();
              var menu = root.getElementById('currencyMenu');
              if (menu) Array.prototype.forEach.call(menu.querySelectorAll('button'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-cur') === window.HP_SELECTED_CURRENCY); });
            }
            function closeMenu() { var m = root.getElementById('currencyMenu'), b = root.getElementById('currencyBtn'); if (m) m.hidden = true; if (b) b.setAttribute('aria-expanded', 'false'); }
            function openMenu() { var m = root.getElementById('currencyMenu'), b = root.getElementById('currencyBtn'); if (m) m.hidden = false; if (b) b.setAttribute('aria-expanded', 'true'); updateThumb(); }
            /* ¿QUE MONEDAS PERTENECEN A UN SOLO PAIS? Se CALCULA del mapa que sirve el Worker —el mismo
               que usa para cobrar— y no se escribe aqui. Hoy salen 13 (peso mexicano, libra, sol,
               quetzal…) y dos compartidas: el euro lo usan 20 paises y el dolar 7. El dia que se anada
               un pais, el calculo se ajusta solo; una segunda lista a mano habria empezado a mentir. */
            function paisUnicoDe(moneda) {
              var mapa = window.HP_PAISES_POR_MONEDA;
              if (!mapa) return null;
              var suyos = [];
              for (var pais in mapa) if (mapa[pais] === moneda) suyos.push(pais);
              return suyos.length === 1 ? suyos[0] : null;
            }
      
            /* Llamado por el selector de la cabecera. Solo cambia si hay precio para esa moneda.
               Y arrastra la LADA si esa moneda es de un pais unico (regla de Enrique, 20-ago-2026):
               quien elige pesos mexicanos esta diciendo donde esta, asi que la lada deberia acompanarle.
               Con el euro o el dolar no se toca: son de veinte y de siete paises, y adivinar cual seria
               inventarselo. Al reves NO ocurre — cambiar la lada no mueve la moneda, porque cuando la
               clienta llega al telefono ya vio el precio y cambiarselo por detras seria una encerrona. */
            /* QUIEN FIJA LA MONEDA (29-ago-2026, «la moneda vuelve con el pedido», decision de Enrique).
               Tres llamadores: el selector (eleccion de la clienta), el modal cuando el banco no admite la
               moneda (eleccion), y el enlace de retomar (la moneda del PEDIDO). Los tres FIJAN la moneda:
               a partir de ahi la geolocalizacion —que llega tarde y por su cuenta— solo propone, no pisa.
               Es el mismo trato que ya tiene la lada (`propuesta: true`). Si los precios aun no cargaron,
               la moneda pedida se APUNTA y la aplica quien los carga: sin esto, un /retomar mas rapido que
               /prices perdia la moneda del pedido en silencio. Una moneda que la tienda no ofrece se
               ignora: manda la geo de hoy (estado 9 del diseno de retomar). */
            window.HP_setCurrency = function (cur, opciones) {
              cur = (cur || '').toLowerCase();
              var propuesta = !!(opciones && opciones.propuesta);
              /* FIJAR LA MONEDA Y ARRASTRAR LA LADA SON DOS COSAS DISTINTAS (auditoria de la etapa L, R1/R2,
                 29-ago-2026). Solo un GESTO de la clienta —el selector o el modal— arrastra la lada por encima de
                 un numero ya escrito (regla 2b del 20-ago). Cuando la moneda llega SOLA, la lada solo se PROPONE:
                 la geo lo hacia bien, pero el enlace de retomar la fijaba como si fuera un gesto, y un pedido en
                 MXN abierto desde España dejaba +34 600 123 456 convertido en +52 600 123 456 —el E.164 que viaja
                 a Stripe y a la orden— porque la lada se movia DESPUES de rellenar el formulario. */
              var ladaPropuesta = propuesta || !!(opciones && opciones.ladaPropuesta);
              /* Se APUNTA solo mientras no hay precios (llegan con /geo): con precios cargados, una moneda que la
                 tienda no ofrece se ignora y no deja residuo (auditoria de la etapa L, B-1). Se apunta CON su
                 caracter, para que quien la aplique despues repita la misma llamada y no otra. */
              if (!window.HP_PRICES[cur]) { if (!propuesta && cur && !Object.keys(window.HP_PRICES).length) window.HP_MONEDA_PEDIDA = { moneda: cur, ladaPropuesta: ladaPropuesta }; return; }
              if (propuesta && window.HP_MONEDA_FIJADA) return;
              if (!propuesta) window.HP_MONEDA_FIJADA = true;
              window.HP_SELECTED_CURRENCY = cur;
              updatePrices();
              updateBtn();
              /* La lada que arrastra una moneda de un solo pais hereda el caracter de la llamada: la geo y el
                 enlace la proponen; una eleccion de la clienta la pone. UNA sola via para las tres. */
              var pais = paisUnicoDe(cur);
              /* EL PAIS DE UNA MONEDA FIJADA PESA MAS QUE LA GEO. Si el pedido (o la clienta) fijo una moneda de un
                 solo pais, la lada que propone la geo despues es ESE pais, no el del IP: sin esto, con el telefono
                 vacio la lada dependia de si /geo contestaba antes o despues del enlace (hallazgo M-2 de la
                 auditoria L). Una moneda de varios paises no dice nada del pais: se borra y manda la geo. */
              if (!propuesta) window.HP_LADA_DE_MONEDA = pais || null;
              if (pais && window.HP_setPhoneCountry) window.HP_setPhoneCountry(pais, ladaPropuesta ? { propuesta: true } : undefined);
              /* Lo FIJADO se recuerda en el navegador: quien elige una moneda y cierra, vuelve a su moneda. */
              if (!propuesta && window.HP_recuerdaCuestionario) window.HP_recuerdaCuestionario();
            };
            function updateThumb() {
              var sc = root.getElementById('currencyMenuScroll'), th = root.getElementById('currencyMenuThumb');
              if (!sc || !th || !th.parentNode) return;
              var trackH = th.parentNode.clientHeight, ratio = sc.clientHeight / (sc.scrollHeight || 1);
              if (ratio >= 1) { th.parentNode.style.display = 'none'; return; } // todo cabe → sin barra
              th.parentNode.style.display = 'block';
              var h = Math.max(28, Math.round(trackH * ratio));
              var maxScroll = sc.scrollHeight - sc.clientHeight;
              th.style.height = h + 'px';
              th.style.top = (maxScroll > 0 ? Math.round((trackH - h) * (sc.scrollTop / maxScroll)) : 0) + 'px';
            }
            function renderSelector() {
              var wrap = root.getElementById('currencySelect'), menu = root.getElementById('currencyMenu'),
                  sc = root.getElementById('currencyMenuScroll'), btn = root.getElementById('currencyBtn');
              if (!wrap || !menu || !sc || !btn) return;
              var avail = CUR_ORDER.filter(function (c) { return typeof window.HP_PRICES[c] === 'number'; });
              if (avail.length < 2) return; // sin datos suficientes → no mostrar (queda el precio fijo)
              sc.innerHTML = avail.map(function (c) {
                return '<button type="button" role="option" data-cur="' + c + '">' +
                  '<img class="currency-flag" src="' + flagUrl(c) + '" alt="" width="20" height="14" decoding="async">' +
                  '<span class="currency-code">' + c.toUpperCase() + '</span>' +
                  '<span class="cur-price">' + fmt(window.HP_PRICES[c], c) + '</span></button>';
              }).join('');
              Array.prototype.forEach.call(sc.querySelectorAll('button'), function (b) {
                b.addEventListener('click', function () { window.HP_setCurrency(b.getAttribute('data-cur')); closeMenu(); });
              });
              sc.addEventListener('scroll', updateThumb);
              updateBtn();
              wrap.hidden = false;
              btn.addEventListener('click', function (e) { e.stopPropagation(); if (menu.hidden) openMenu(); else closeMenu(); });
              document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) closeMenu(); });
            }
            Promise.all([
              /* En el carril de prueba se puede simular el pais: `?test_country=ES`. Va SOLO cuando la
                 pagina se sirve en local con `?entorno=prueba` —el mismo candado que elige el Worker—,
                 y ademas el Worker de produccion no lleva la variable que lo habilita: aunque alguien
                 lo escribiera en la tienda no haria nada, alli el pais lo fija Cloudflare por IP en el
                 borde. Sin esto, la geolocalizacion solo se prueba desde donde uno este sentado — mi
                 maquina responde MX siempre, asi que Espana nunca pasaba por el camino real.
                 Escrito como funcion y no como ternario anidado: la primera version lo era, no
                 funcionaba, y no habia forma de ver por que mirandola. */
              fetch(API + '/geo' + (function () {
                if (!window.HP_PIDE_PRUEBA) return '';
                var m = /[?&]test_country=([A-Za-z]{2})(?:&|$)/.exec(location.search);
                return m ? '?test_country=' + m[1].toUpperCase() : '';
              })()).then(function (r) { return r.json(); }).catch(function () { return {}; }),
              fetch(API + '/prices').then(function (r) { return r.json(); }).catch(function () { return {}; })
            ]).then(function (res) {
              var geo = res[0] || {}, pr = res[1] || {};
              if (pr.prices) window.HP_PRICES = pr.prices;
              if (pr.paises) window.HP_PAISES_POR_MONEDA = pr.paises;   // para calcular las monedas de un solo pais
              /* LA MONEDA: primero la que PIDIO el enlace de retomar mientras los precios no estaban (si la
                 tienda la ofrece); si no, la de la geo — y solo si nadie la fijo antes (29-ago-2026). */
              var pedida = window.HP_MONEDA_PEDIDA;
              /* Solo se descarta si la tienda CONTESTO con precios: ahi hubo veredicto (la ofrece o no). Sin precios
                 la peticion sigue pendiente, y la memoria la conserva (ver recuerda()). */
              if (pr.prices) window.HP_MONEDA_PEDIDA = null;
              /* UNA SOLA VIA (auditoria de la etapa L): la moneda pedida por el enlace y la que propone la geo
                 pasan por HP_setCurrency, como la eleccion del selector. Antes la rama «pedida» asignaba inline
                 y no arrastraba la lada, y la geo tampoco pasaba por aqui: dos caminos para la misma moneda con
                 efectos distintos, y un guard sin llamador. La propuesta no pisa lo fijado (la funcion lo sabe). */
              if (pedida && window.HP_PRICES[pedida.moneda]) window.HP_setCurrency(pedida.moneda, { ladaPropuesta: !!pedida.ladaPropuesta });
              if (geo.currency) window.HP_setCurrency(geo.currency, { propuesta: true });
              /* Y SI LA TIENDA CONTESTO QUE NO LA OFRECE, la memoria lo refleja YA, no al primer tecleo: con veredicto,
                 la moneda pedida deja de ser «la que esta visita quiere» (nota de la re-verificacion, 30-ago-2026). */
              if (pr.prices && pedida && !window.HP_PRICES[pedida.moneda] && window.HP_recuerdaCuestionario) window.HP_recuerdaCuestionario();
              /* UN SOLO RESPALDO PARA LAS DOS COSAS (20-ago-2026, decision de Enrique).
                 La moneda ya caia a EUR cuando la geolocalizacion no contestaba, pero la lada se
                 quedaba en lo que hubiera adivinado el navegador — y quedaba un estado incoherente:
                 «149 €» con lada +52. Dos respaldos distintos que no se hablan es peor que no tener
                 respaldo, porque el resultado parece deliberado.
                 Si no sabemos donde esta, decimos MEXICO en las dos. La REGLA no cambio —moneda y
                 lada tienen que ir de acuerdo—; cambio su razon: desde el 7-sep-2026 Mexico toma el
                 lugar de Espana como mercado principal, que es donde se pauta. Enrique: «Mexico toma
                 el lugar de Espana como prioridad». El respaldo del precio de mas abajo va atado a
                 esto: si aqui dice MX, el precio escrito a mano tiene que estar en pesos. */
              var paisFinal = geo.country || 'MX';
              window.HP_GEO_COUNTRY = paisFinal;
              /* La geo PROPONE la lada, y propone el pais de la moneda ya fijada si la hay (ver HP_setCurrency):
                 asi la lada no depende del orden en que contestan /geo y /retomar. */
              if (window.HP_setPhoneCountry) window.HP_setPhoneCountry(window.HP_LADA_DE_MONEDA || paisFinal, { propuesta: true });
              updatePrices();
              renderSelector();
            });
          })();
      
      /* RIEL DE SCROLL SIEMPRE VISIBLE — la barra nativa de un contenedor depende del navegador: en el
             mismo iPhone, Safari la pinta y Chrome no, asi que un recuadro con mas contenido debajo parece
             una tabla cortada segun con que entres. Mismo patron que el selector de moneda, hecho generico:
             cualquier elemento con [data-riel] se envuelve y recibe su riel, que se esconde solo si todo cabe. */
          (function () {
            function montar(cont) {
              if (cont.dataset.rielMontado === '1') return;
              cont.dataset.rielMontado = '1';
              var env = document.createElement('div');
              env.className = 'riel-envoltura';
              cont.parentNode.insertBefore(env, cont);
              env.appendChild(cont);
              var riel = document.createElement('div'); riel.className = 'riel';
              var pulgar = document.createElement('div'); pulgar.className = 'riel-pulgar';
              riel.appendChild(pulgar); env.appendChild(riel);
              function actualizar() {
                var alto = cont.clientHeight, total = cont.scrollHeight || 1;
                if (alto / total >= 0.999) { riel.style.display = 'none'; return; }
                riel.style.display = 'block';
                /* EL RIEL SE COLOCA RESPECTO A LA CAJA, NO A LA ENVOLTURA (18-ago-2026, hallazgo de Enrique en
                   escritorio: se veian DOS barras). La envoltura ocupa todo el ancho del contenedor (1132 px)
                   y la caja va centrada dentro (900 px), asi que un `right: 5px` de la envoltura dejaba el riel
                   105 px FUERA del recuadro. En movil la caja llenaba la envoltura y no se notaba: el defecto
                   estaba desde el primer dia, escondido por una coincidencia. Derivarlo de la caja lo vuelve
                   imposible, mida lo que mida cada una. */
                riel.style.left = (cont.offsetLeft + cont.clientWidth - 11) + 'px';
                riel.style.right = 'auto';
                riel.style.top = (cont.offsetTop + 10) + 'px';
                riel.style.bottom = 'auto';
                riel.style.height = Math.max(0, cont.clientHeight - 20) + 'px';
                var pista = riel.clientHeight;
                var h = Math.max(30, Math.round(pista * (alto / total)));
                var max = total - alto;
                pulgar.style.height = h + 'px';
                pulgar.style.top = (max > 0 ? Math.round((pista - h) * (cont.scrollTop / max)) : 0) + 'px';
              }
              cont.addEventListener('scroll', actualizar, { passive: true });
              window.addEventListener('resize', actualizar);
              if (window.ResizeObserver) { try { new ResizeObserver(actualizar).observe(cont); } catch (e) {} }
              actualizar();
              setTimeout(actualizar, 400);
            }
            function arrancar() { var l = root.querySelectorAll('[data-riel]'); for (var i = 0; i < l.length; i++) montar(l[i]); }
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
          })();
      
      /* ════════════════════════════════════════════════════════════════════════════════════════════
             EL CORREO DEL LIBRO ENTRA EN LA LISTA NEWSLETTER DE KLAVIYO (19-ago-2026)
             ════════════════════════════════════════════════════════════════════════════════════════════
             Este formulario existia desde el principio y NO estaba conectado a nada: al pulsar, la pagina
             recargaba y el correo se perdia. La captacion vivia en un formulario de bloque de Klaviyo que
             estaba en el pie del tema, y que se borro por error.
      
             POR QUE ASI:
             · Se llama al endpoint de CLIENTE de Klaviyo, que usa la clave PUBLICA (la misma que el tema ya
               lleva en su script) y esta pensado para el navegador. La clave privada NO puede estar aqui:
               su endpoint de servidor lo prohibe expresamente y seria regalarla.
             · Entrar en la lista XmjPdC es lo que dispara la serie de bienvenida: ese flujo se activa por
               «Added to List», no por un formulario concreto. Comprobado en la cuenta.
             · Los bloqueadores de anuncios cortan a.klaviyo.com. Esos visitantes YA se perdian con el
               formulario anterior, que enviaba al mismo sitio. Por eso hay una RED: si la llamada no sale,
               el correo se guarda en la propia tienda (mismo origen, nada lo bloquea) y se etiqueta, para
               que no se pierda y para que se vea que paso.
             · Y pase lo que pase, la persona VE el resultado. Un envio que aparenta exito y no llega es el
               peor fallo posible en captacion.
             ════════════════════════════════════════════════════════════════════════════════════════════ */
          (function () {
            /* VALIDACION BASICA, NO UN FILTRO PESADO (19-ago-2026, matiz de Enrique). Solo se rechaza lo que
               REBOTA seguro: sin arroba, sin punto en el dominio, con espacios, con dos arrobas o terminado en
               punto. Nada de listas de dominios ni de comprobar si el buzon existe: eso rechaza correos buenos,
               que en captacion cuesta mas caro que aceptar uno malo. Y el mensaje distingue VACIO de MAL
               ESCRITO, porque no se arreglan igual: uno pide escribir, el otro pide mirar. */
            var RE_CORREO = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[a-zA-Z]{2,}$/;
            function estado(el, tono, html) {
              if (!el) return;
              el.hidden = false; el.setAttribute('data-tono', tono); el.innerHTML = html;
            }
            function arrancar() {
              var form = root.querySelector('.libro-form');
              if (!form || form.dataset.libroConectado === '1') return;
              form.dataset.libroConectado = '1';
              var campo = form.querySelector('input[type=email]');
              var msg = form.querySelector('.libro-estado');
              var EMPRESA = form.getAttribute('data-klaviyo-empresa');
              var LISTA = form.getAttribute('data-klaviyo-lista');
              var REVISION = form.getAttribute('data-klaviyo-revision');
      
              /* CANDADO CONTRA EL DOBLE ENVIO. Bloquear el boton con estilo (pointer-events) NO detiene un
                 segundo clic: ni uno programatico ni el de alguien impaciente que pulsa dos veces antes de que
                 el navegador repinte. Dos envios = dos peticiones y, en un mal dia, dos perfiles. El candado
                 es una variable, no una clase de CSS (19-ago-2026, lo cazo la prueba de doble clic). */
              var enviando = false;
              form.addEventListener('submit', function (ev) {
                ev.preventDefault();
                if (enviando) return;
                var correo = (campo && campo.value || '').trim();
                if (!correo) {
                  estado(msg, 'mal', 'Escribe tu correo y te mando el libro.');
                  if (campo) campo.focus();
                  return;
                }
                if (!RE_CORREO.test(correo)) {
                  var pista = correo.indexOf('@') < 0 ? 'Falta la @.'
                    : correo.split('@').length > 2 ? 'Sobra una @.'
                    : /\s/.test(correo) ? 'Sobra un espacio.'
                    : 'Falta el punto del dominio (por ejemplo, .com).';
                  estado(msg, 'mal', pista + ' Revisa el correo y vuelve a intentarlo.');
                  if (campo) campo.focus();
                  return;
                }
                enviando = true;
                form.classList.add('enviando');
                estado(msg, 'ok', 'Enviando…');
      
                var cuerpo = JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: {
                  email: correo, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
                  relationships: { list: { data: { type: 'list', id: LISTA } } } } });
      
                fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(EMPRESA), {
                  method: 'POST', headers: { 'content-type': 'application/json', revision: REVISION }, body: cuerpo,
                }).then(function (r) {
                  if (!r.ok) throw new Error('HTTP ' + r.status);
                  enviando = false; form.classList.remove('enviando');
                  /* LEAD · libro. Se manda DESPUES de que Klaviyo confirme, no al pulsar: un lead que
                     nunca llego a Klaviyo no es un lead, y contarlo inflaria el numero justo donde duele. */
                  /* IDENTIFICAR ANTES DE CONTAR (encargo de Enrique). El correo lo acaba de escribir
                     ella; si el `Lead` sale antes de decirselo al pixel, sale anonimo — y ese es justo
                     el evento que mas falta hace emparejar. El orden importa, no es cosmetico. */
                  if (window.HP_PIXEL) {
                    window.HP_PIXEL.identifica({ email: correo, pais: window.HP_GEO_COUNTRY });
                    window.HP_PIXEL.lead('libro');
                  }
                  estado(msg, 'ok', 'Listo. Te lo mando al correo ahora mismo — revisa tambien la carpeta de promociones.');
                  if (campo) campo.value = '';
                }).catch(function () {
                  /* RED: no se pudo hablar con Klaviyo (bloqueador, red, corte). El correo NO se pierde: se
                     guarda en la tienda con una etiqueta para poder recuperarlo, y se dice la verdad. */
                  var datos = new FormData();
                  datos.append('form_type', 'customer');
                  datos.append('utf8', '\u2713');
                  datos.append('contact[email]', correo);
                  datos.append('contact[tags]', 'libro-gratis,klaviyo-no-alcanzable');
                  datos.append('contact[accepts_marketing]', 'true');
                  return fetch('/contact#contact_form', { method: 'POST', body: datos }).then(function () {
                    enviando = false; form.classList.remove('enviando');
                    // El lead se capturo igual, por la via de respaldo: cuenta lo mismo.
                    /* IDENTIFICAR ANTES DE CONTAR (encargo de Enrique). El correo lo acaba de escribir
                     ella; si el `Lead` sale antes de decirselo al pixel, sale anonimo — y ese es justo
                     el evento que mas falta hace emparejar. El orden importa, no es cosmetico. */
                  if (window.HP_PIXEL) {
                    window.HP_PIXEL.identifica({ email: correo, pais: window.HP_GEO_COUNTRY });
                    window.HP_PIXEL.lead('libro');
                  }
                    estado(msg, 'ok', 'Apuntado. Te lo mando en cuanto lo revise — puede tardar un poco mas de lo normal.');
                    if (campo) campo.value = '';
                  }).catch(function () {
                    enviando = false; form.classList.remove('enviando');
                    estado(msg, 'mal', 'No he podido guardarlo. Escribeme por <a href="https://wa.me/525594357257?text=Quiero%20el%20libro%20gratis" target="_blank" rel="noopener">WhatsApp</a> y te lo mando yo.');
                  });
                });
              });
            }
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
          })();
      
      /* ═══════════════════════════════════════════════════════════════════════════════════════
             RETOMAR EL CUESTIONARIO (etapa 4 de DESIGN-retomar-cuestionario.md, 29-ago-2026)
             ═══════════════════════════════════════════════════════════════════════════════════════
             Dos mecanismos que cubren poblaciones DISTINTAS y no se sustituyen:
      
               · EL ENLACE DEL CORREO (`?retomar=<codigo>`): quien abrio el modal de pago y abandono. Su
                 cuestionario vive en Stripe; el Worker lo devuelve por `/retomar`. Funciona desde
                 cualquier dispositivo — rellena en el ordenador, abre el correo en el movil.
               · LA MEMORIA DEL NAVEGADOR (`localStorage`): quien abandono a mitad del formulario, o
                 recargo, o cerro la pestana. Nunca llego a generar cobro ni correo. Solo en este navegador.
      
             LOS SIETE ESTADOS del cruce (token × memoria) estan en el diseno §3 y cada uno tiene su
             prueba en `_qa-retomar.mjs`. La regla de precedencia, declarada una vez: TOKEN > MEMORIA >
             VACIO. El token es la intencion explicita del clic y el dato del servidor.
      
             LO QUE NO PUEDE PASAR, y como se garantiza:
               · Sin `?retomar=` y sin memoria, la pagina es IDENTICA a la de hoy: ni una peticion de mas.
                 Se prueba comparando el DOM, no prometiendolo.
               · La landing NO ESPERA al Worker para pintarse. Esto corre al final, tras el DOM, y una
                 peticion que falla o tarda cae a la memoria o al vacio SIN ningun mensaje. Un enlace
                 caducado lleva al formulario de siempre, no a un muro de error.
               · El modal de Stripe no se toca: esto rellena campos, hace scroll y escribe la memoria; nada mas.
      
             EL CODIGO ES UNA CAPACIDAD AL PORTADOR POR 30 DIAS y viaja en `location.href`. El pixel de
             Meta y el rastreo de Klaviyo mandan la URL completa a sus registros, asi que en cuanto se lee
             se BORRA de la barra con `history.replaceState`. Eso REDUCE la ventana, no la cierra: el pixel
             puede leer la URL antes de que este bloque corra (medido: una carrera de milisegundos que hoy
             gana el borrado, no por diseno), y Klaviyo ya tiene el codigo por construccion —lo rastrea al
             hacer clic en el correo. Y se lee con `URLSearchParams`, nunca con una
             expresion sobre la query: Klaviyo anade `&_kx=…` a todo enlace rastreado.
      
             Dentro del Shadow DOM el build reescribe `document.getElementById/querySelector(All)` a la
             raiz de la landing, como en el resto de bloques; por eso se usan esos tres y no otros. */
          (function () {
            var CLAVE_MEMORIA = 'hp:cuestionario:v2';
            /* La memoria CADUCA: 30 dias, el mismo invariante que el codigo del correo. Una memoria sin fecha
               era un cuestionario con nombre, correo y telefono viviendo para siempre en un ordenador
               compartido (auditoria, 29-ago-2026). La clave sube a v2 para que lo guardado por la version
               sin fecha no se lea. */
            var VIGENCIA_MEMORIA_MS = 30 * 24 * 60 * 60 * 1000;
            /* Tope de espera al Worker. Sin el, una respuesta tardia —una red mala, un Worker lento— pisaba
               lo que la clienta ya estaba tecleando y la mandaba de golpe al cuestionario (medido por la
               auditoria con un Worker a 4 s). Pasado el tope se cae a la memoria, como si no hubiera
               contestado. */
            var TOPE_WORKER_MS = 4000;
            /* Lo que la clienta ha TOCADO ella misma desde que cargo la pagina. Un relleno tardio no lo pisa. */
            var tocados = {};
            var PARAMETRO = 'retomar';
            /* Lo que NO se recuerda ni se rellena desde el enlace: el consentimiento —uno que llega marcado
               de fabrica no es un consentimiento— y el correo del ebook, que es otro formulario. Es la misma
               lista blanca que el Worker aplica al devolver; aqui se repite del lado del navegador para que
               una memoria vieja tampoco lo cuele. */
            var NO_SE_RELLENAN = { acepta_marketing: true, libro_email: true };
      
            function ambito() { return root.getElementById('solicitar'); }
            function controles() {
              var a = ambito();
              return a ? Array.prototype.slice.call(a.querySelectorAll('input[name], select[name], textarea[name]')) : [];
            }
            function dispara(el, tipo) { try { el.dispatchEvent(new Event(tipo, { bubbles: true })); } catch (_) {} }
      
            /* ── RELLENAR ──
               Radios: se hace CLICK, no `checked = true`, para que `data-visible-if` reevalue y el detalle
               de alergias aparezca. Texto: valor + eventos `input` y `change`, que es lo que escuchan la
               memoria y la validacion. Telefono: el campo `tutor_telefono` es oculto y se compone desde la
               lada y el numero; se reparte con el helper del bloque del telefono, que conoce los paises. */
            function rellena(campos, opciones) {
              if (!campos || typeof campos !== 'object') return 0;
              var puestos = 0;
              var radiosVistos = {};
              var respeta = !!(opciones && opciones.respetaTocados);
              controles().forEach(function (el) {
                var name = el.getAttribute('name');
                if (!name || NO_SE_RELLENAN[name]) return;
                var v = campos[name];
                if (v === undefined || v === null || v === '') return;
                if (respeta && tocados[name]) return;
                v = String(v);
                if (el.type === 'radio') {
                  if (radiosVistos[name]) return;
                  var r = ambito().querySelector('input[name="' + name + '"][value="' + v.replace(/"/g, '') + '"]');
                  /* `checked = true` + evento SINTETICO, nunca `click()`: un click fabrica eventos confiables y
                     el pixel lo contaria como la primera interaccion de la clienta (auditoria, 29-ago). El
                     `change` sintetico basta para que `data-visible-if` reevalue y la memoria se entere. */
                  if (r) { radiosVistos[name] = true; if (!r.checked) { r.checked = true; dispara(r, 'change'); } puestos++; }
                  return;
                }
                if (el.type === 'checkbox') return;   // ninguno autorizado hoy; si un dia lo hay, aqui
                if (name === 'tutor_telefono') {
                  if (window.HP_setPhoneE164 && window.HP_setPhoneE164(v)) puestos++;
                  return;
                }
                if (el.type === 'hidden') return;
                el.value = v;
                dispara(el, 'input');
                dispara(el, 'change');
                puestos++;
              });
              /* IDENTIFICAR NO ES CONTAR (31-ago-2026, «que los eventos vayan ricos»). Los datos que este
                 relleno repone —del enlace de retomar o de la memoria— son identidad CONOCIDA, y nadie la
                 aplicaba al pixel: la clienta que volvia del correo tocaba un campo y su CustomizeProduct
                 salia ANONIMO — justo la del retargeting. Aqui, el embudo comun de TODO relleno, se
                 identifica con lo que el formulario ya tiene, venga de donde venga. No dispara ningun
                 evento (identificar no cuenta): solo hace que lo que se cuente despues valga mas. */
              if (puestos && window.HP_PIXEL) {
                var idd = {};
                var elId;
                if ((elId = ambito().querySelector('[name="tutor_email"]')) && elId.value) idd.email = elId.value;
                if ((elId = ambito().querySelector('[name="tutor_telefono"]')) && elId.value) idd.telefono = elId.value;
                if ((elId = ambito().querySelector('[name="tutor_nombre"]')) && elId.value) idd.nombre = elId.value;
                if (idd.email || idd.telefono || idd.nombre) { idd.pais = window.HP_GEO_COUNTRY; try { window.HP_PIXEL.identifica(idd); } catch (_) {} }
              }
              return puestos;
            }
      
            /* ── LA MEMORIA ──
               Se guarda a cada cambio lo que la clienta ha escrito, con la misma forma que el formulario
               manda al Worker. `localStorage` y no `sessionStorage`: sobrevive a cerrar la pestana, que es
               justo el caso que se quiere cubrir. Todo dentro de try: en privado o con el almacen
               bloqueado, la landing tiene que seguir igual. */
            function lee() {
              try {
                var c = JSON.parse(localStorage.getItem(CLAVE_MEMORIA) || 'null');
                if (!c || typeof c !== 'object' || !c.campos || typeof c.campos !== 'object' || typeof c.en !== 'number') return null;
                if (Date.now() - c.en > VIGENCIA_MEMORIA_MS) { localStorage.removeItem(CLAVE_MEMORIA); return null; }
                return { campos: c.campos, moneda: typeof c.moneda === 'string' ? c.moneda : null };
              } catch (_) { return null; }
            }
            function recuerda() {
              try {
                var d = {};
                controles().forEach(function (el) {
                  var name = el.getAttribute('name');
                  if (!name || NO_SE_RELLENAN[name]) return;
                  if (el.type === 'radio') { if (el.checked) d[name] = el.value; return; }
                  if (el.type === 'checkbox') return;
                  var v = (el.value || '').trim();
                  if (v) d[name] = v;
                });
                /* LA MONEDA FIJADA TAMBIEN SE RECUERDA (decision de Enrique, 29-ago-2026): la que eligio ella o la que
                   trajo el enlace del pedido. La que solo propuso la geo, no: asi, si vuelve desde otro pais, se nota. */
                /* Y LA QUE SE GUARDA ES LA QUE ESTA VISITA QUIERE: la fijada o, mientras /prices no contesta, la PEDIDA
                   (por el enlace o por la propia memoria). Sin esa segunda rama, reponer la memoria la re-escribia con
                   null antes de que llegaran los precios y, si /prices fallaba, la moneda recordada se borraba para
                   siempre (re-verificacion de la auditoria L, 30-ago-2026). */
                var pedida = window.HP_MONEDA_PEDIDA;
                var moneda = window.HP_MONEDA_FIJADA && window.HP_SELECTED_CURRENCY ? String(window.HP_SELECTED_CURRENCY) : (pedida && pedida.moneda ? String(pedida.moneda) : null);
                if (Object.keys(d).length || moneda) localStorage.setItem(CLAVE_MEMORIA, JSON.stringify({ v: 2, en: Date.now(), campos: d, moneda: moneda }));
                else localStorage.removeItem(CLAVE_MEMORIA);
              } catch (_) {}
            }
            function olvida() { try { localStorage.removeItem(CLAVE_MEMORIA); } catch (_) {} }
            window.HP_olvidaCuestionario = olvida;
            window.HP_recuerdaCuestionario = recuerda;   // lo llama HP_setCurrency al FIJAR una moneda (eleccion o enlace)
      
            controles().forEach(function (el) {
              var marca = function (ev) { if (ev && ev.isTrusted) tocados[el.getAttribute('name')] = true; recuerda(); };
              el.addEventListener('input', marca);
              el.addEventListener('change', marca);
            });
            /* EL TELEFONO VISIBLE no tiene `name` (lo tiene el E.164 oculto, que solo recibe eventos sinteticos):
               sin esto, lo que la clienta teclea en el telefono mientras el Worker tarda se pisaba con el del
               pedido (auditoria de la etapa L, M-1). Se marca como tocado con el nombre del control que se rellena. */
            var telVisible = ambito().querySelector('#phoneLocalInput');
            if (telVisible) telVisible.addEventListener('input', function (ev) { if (ev && ev.isTrusted) tocados.tutor_telefono = true; });
      
            /* ── EL ENLACE ──
               Se lee, se BORRA de la barra, y se pide al Worker. Cualquier fallo —codigo invalido,
               caducado, Worker caido, respuesta rara— cae a la memoria sin un solo mensaje. */
            function codigoDelEnlace() {
              try {
                var q = new URLSearchParams(location.search);
                var t = q.get(PARAMETRO);
                if (!t) return null;
                q.delete(PARAMETRO);
                var limpia = location.pathname + (q.toString() ? '?' + q.toString() : '') + location.hash;
                try { history.replaceState(history.state, '', limpia); } catch (_) {}
                return t;
              } catch (_) { return null; }
            }
      
            function enfoca() {
              var s = ambito();
              if (s && s.scrollIntoView) { try { s.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (_) { s.scrollIntoView(); } }
            }
      
            function desdeMemoria() {
              var m = lee();
              if (!m) return false;
              /* La moneda recordada se repone como la del enlace: FIJA la moneda y solo PROPONE la lada (el telefono
                 recordado, si lo hay, manda). Y nunca pisa una que ya se haya fijado en esta visita. */
              if (m.moneda && window.HP_setCurrency && !window.HP_MONEDA_FIJADA) window.HP_setCurrency(m.moneda, { ladaPropuesta: true });
              if (!m.campos || !Object.keys(m.campos).length) return false;
              rellena(m.campos);
              recuerda();     // fijar la moneda re-escribe la memoria antes de rellenar: se vuelve a guardar entera
              return true;
            }
      
            var codigo = codigoDelEnlace();
            window.HP_RETOMAR = { origen: 'vacio' };   // lo lee la prueba de los siete estados
            if (!codigo) {
              if (desdeMemoria()) window.HP_RETOMAR.origen = 'memoria';
              return;
            }
            if (!window.HP_API_BASE || typeof fetch !== 'function') { if (desdeMemoria()) window.HP_RETOMAR.origen = 'memoria'; return; }
            var aborta = (typeof AbortController === 'function') ? new AbortController() : null;
            var reloj = setTimeout(function () { if (aborta) aborta.abort(); }, TOPE_WORKER_MS);
            window.HP_RETOMAR.pendiente = fetch(window.HP_API_BASE + '/retomar?t=' + encodeURIComponent(codigo), { method: 'GET', signal: aborta ? aborta.signal : undefined })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (j) {
                clearTimeout(reloj);
                var campos = j && j.campos;
                /* LA MONEDA DEL PEDIDO, antes de rellenar: `HP_setCurrency` la fija (y arrastra la lada si es
                   de un solo pais), y el telefono del formulario, que se rellena despues, pone la suya. Si la
                   tienda ya no ofrece esa moneda, se ignora y manda la geo de hoy, sin ruido. */
                /* …salvo que la clienta ya haya ELEGIDO una mientras el Worker tardaba: lo que hizo mientras
                   esperaba se respeta, igual que los campos que teclea (auditoria de la etapa L, B-2). */
                if (j && typeof j.moneda === 'string' && window.HP_setCurrency && !window.HP_MONEDA_FIJADA) window.HP_setCurrency(j.moneda, { ladaPropuesta: true });
                if (campos && typeof campos === 'object' && rellena(campos, { respetaTocados: true }) > 0) {
                  window.HP_RETOMAR.origen = 'enlace';
                  recuerda();     // lo recuperado del servidor pasa a ser tambien la memoria de este navegador
                  enfoca();
                } else if (desdeMemoria()) window.HP_RETOMAR.origen = 'memoria';
              })
              .catch(function () { clearTimeout(reloj); if (desdeMemoria()) window.HP_RETOMAR.origen = 'memoria'; });
          })();
    } catch (e) { /* no romper la pagina */ }

    // ---- scroll suave a anclas internas (#solicitar, etc.) dentro del shadow ----
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var t = root.getElementById(id) || root.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }
  function boot() {
    document.querySelectorAll('.hp-landing-v2-host').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // Shopify theme editor: re-init si la seccion se recarga
  document.addEventListener('shopify:section:load', boot);
})();